import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Json: { input: any; output: any; }
};

export type Case = {
  __typename?: 'Case';
  assignedTo?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  priority?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
};

/** Check case delete permissions response */
export type CheckCaseDeletePermissions = {
  __typename?: 'CheckCaseDeletePermissions';
  /** Delete permission check results for cases */
  data?: Maybe<Scalars['Json']['output']>;
};

/** Convert to Advanced Query response */
export type ConvertToAdvancedQuery = {
  __typename?: 'ConvertToAdvancedQuery';
  /** Converted advanced query string */
  data?: Maybe<Scalars['Json']['output']>;
};

/** Create case response */
export type CreateCase = {
  __typename?: 'CreateCase';
  /** Created case data */
  data?: Maybe<Scalars['Json']['output']>;
};

/** Input for creating a case directly with fields array structure */
export type CreateCaseDirectInput = {
  /** Array of attachments */
  attachments?: InputMaybe<Array<InputMaybe<Scalars['Json']['input']>>>;
  /** Stringified JSON array of case fields with complete field definitions */
  fields: Scalars['String']['input'];
  /** Issue type string for tasks */
  issueTypeString?: InputMaybe<Scalars['String']['input']>;
};

/** Input for creating a new case */
export type CreateCaseInput = {
  /** Any additional dynamic fields as JSON object */
  additionalData?: InputMaybe<Scalars['Json']['input']>;
  /** Assigned user name */
  assigneeUserName?: InputMaybe<Scalars['String']['input']>;
  /** Description JSON string */
  descriptionJsonString?: InputMaybe<Scalars['String']['input']>;
  /** Case description */
  descriptionRaw?: InputMaybe<Scalars['String']['input']>;
  /** Flow ID for integration/command tasks */
  flowId?: InputMaybe<Scalars['String']['input']>;
  /** Form instance data as JSON string for form tasks */
  formInstance?: InputMaybe<Scalars['String']['input']>;
  /** Issue type string for tasks */
  issueTypeString?: InputMaybe<Scalars['String']['input']>;
  /** Parent case ID for sub-cases */
  parent?: InputMaybe<Scalars['String']['input']>;
  /** Case priority */
  priority?: InputMaybe<Scalars['String']['input']>;
  /** Reporter user name */
  reporterUserName?: InputMaybe<Scalars['String']['input']>;
  /** Case status */
  status?: InputMaybe<Scalars['String']['input']>;
  /** Task parameters as JSON object */
  taskParameter?: InputMaybe<Scalars['Json']['input']>;
  /** Case title */
  title: Scalars['String']['input'];
};

/** Simplified input for creating a case via SOAR API */
export type CreateCaseInputSoar = {
  /** Case description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Case priority */
  priority?: InputMaybe<Scalars['String']['input']>;
  /** Case title */
  title?: InputMaybe<Scalars['String']['input']>;
  /** Case type */
  type: Scalars['String']['input'];
};

/** Create saved search response */
export type CreateSavedSearch = {
  __typename?: 'CreateSavedSearch';
  /** Created saved search data */
  data?: Maybe<Scalars['Json']['output']>;
};

export type CreateSavedSearchInput = {
  /** Name of the saved search */
  name: Scalars['String']['input'];
  /** Query string for the search */
  query: Scalars['String']['input'];
  /** Type of query - either 'basic' or 'advanced' */
  queryType: Scalars['String']['input'];
};

/** Create vector destination response */
export type CreateVectorDestination = {
  __typename?: 'CreateVectorDestination';
  /** Created vector destination data */
  data?: Maybe<Scalars['Json']['output']>;
};

/** Input for creating a vector destination */
export type CreateVectorDestinationInput = {
  /** Additional destination configuration as JSON */
  config?: InputMaybe<Scalars['Json']['input']>;
  /** S3 bucket path or DVO endpoint URL */
  endpoint?: InputMaybe<Scalars['String']['input']>;
  /** Display name for the destination */
  name: Scalars['String']['input'];
  /** Destination type (e.g. s3, dvo) */
  type?: InputMaybe<Scalars['String']['input']>;
};

/** Create vector rule response */
export type CreateVectorRule = {
  __typename?: 'CreateVectorRule';
  /** Created vector rule data */
  data?: Maybe<Scalars['Json']['output']>;
};

/** Input for creating a vector rule */
export type CreateVectorRuleInput = {
  /** Route or Reject */
  action?: InputMaybe<Scalars['String']['input']>;
  /** Additional rule configuration as JSON */
  config?: InputMaybe<Scalars['Json']['input']>;
  /** Destination name for matched data */
  destination?: InputMaybe<Scalars['String']['input']>;
  /** Whether the rule is enabled */
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** RegEx pattern for log filtering */
  filterRegex?: InputMaybe<Scalars['String']['input']>;
  /** Descriptive name for the rule */
  name: Scalars['String']['input'];
  /** Order of rule evaluation (1 = first) */
  priority?: InputMaybe<Scalars['Int']['input']>;
  /** Source name this rule applies to */
  source?: InputMaybe<Scalars['String']['input']>;
  /** Status string for the external API (enabled/disabled) */
  status?: InputMaybe<Scalars['String']['input']>;
};

/** Create vector source response */
export type CreateVectorSource = {
  __typename?: 'CreateVectorSource';
  /** Created vector source data */
  data?: Maybe<Scalars['Json']['output']>;
};

/** Input for creating a vector source */
export type CreateVectorSourceInput = {
  /** IP or hostname of the source */
  address?: InputMaybe<Scalars['String']['input']>;
  /** Cloud collector identifier when using a cloud collector source */
  collectorId?: InputMaybe<Scalars['String']['input']>;
  /** Additional source configuration as JSON */
  config?: InputMaybe<Scalars['Json']['input']>;
  /** Data format (e.g. DVO) */
  format?: InputMaybe<Scalars['String']['input']>;
  /** Display name for the source */
  name: Scalars['String']['input'];
  /** Protocol (e.g. syslog, http) */
  type?: InputMaybe<Scalars['String']['input']>;
};

/** Delete attachment response */
export type DeleteAttachment = {
  __typename?: 'DeleteAttachment';
  /** Delete confirmation */
  data?: Maybe<Scalars['Json']['output']>;
};

/** Delete case response */
export type DeleteCase = {
  __typename?: 'DeleteCase';
  /** Result of single case delete operation */
  data?: Maybe<Scalars['Json']['output']>;
};

/** Delete Cases response */
export type DeleteCases = {
  __typename?: 'DeleteCases';
  /** Result of bulk delete operation */
  data?: Maybe<Scalars['Json']['output']>;
};

/** Delete comment response */
export type DeleteComment = {
  __typename?: 'DeleteComment';
  /** Delete confirmation */
  data?: Maybe<Scalars['Json']['output']>;
};

/** Delete saved search response */
export type DeleteSavedSearch = {
  __typename?: 'DeleteSavedSearch';
  /** Delete confirmation */
  data?: Maybe<Scalars['Json']['output']>;
};

/** Delete vector destination response */
export type DeleteVectorDestination = {
  __typename?: 'DeleteVectorDestination';
  /** Delete vector destination result */
  data?: Maybe<Scalars['Json']['output']>;
};

/** Delete vector rule response */
export type DeleteVectorRule = {
  __typename?: 'DeleteVectorRule';
  /** Delete vector rule result */
  data?: Maybe<Scalars['Json']['output']>;
};

/** Delete vector source response */
export type DeleteVectorSource = {
  __typename?: 'DeleteVectorSource';
  /** Delete vector source result */
  data?: Maybe<Scalars['Json']['output']>;
};

/** Download attachment response */
export type DownloadAttachment = {
  __typename?: 'DownloadAttachment';
  /** Attachment download data including URL or content */
  data?: Maybe<Scalars['Json']['output']>;
};

/** Download cases CSV response */
export type DownloadCasesCsv = {
  __typename?: 'DownloadCasesCsv';
  /** CSV content as string or download URL */
  data?: Maybe<Scalars['String']['output']>;
};

/** Input for downloading cases as CSV */
export type DownloadCasesCsvInput = {
  /** Assignee filter */
  assignee?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** List of column fields to include in CSV export */
  downloadFields?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Additional fields (for API compatibility) */
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Priority filter */
  priority?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Advanced query string (advanced mode) */
  query?: InputMaybe<Scalars['String']['input']>;
  /** Column to sort by */
  sortCol?: InputMaybe<Scalars['String']['input']>;
  /** Sort order (asc or desc) */
  sortOrder?: InputMaybe<Scalars['String']['input']>;
  /** Status filter */
  status?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Text search query (basic mode) */
  text?: InputMaybe<Scalars['String']['input']>;
  /** Case types filter */
  types?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** Input for updating a single field */
export type FieldUpdateInput = {
  /** Field ID */
  id: Scalars['String']['input'];
  /** Field value (can be any JSON type) */
  value?: InputMaybe<Scalars['Json']['input']>;
};

/** Status options response */
export type GetAllStatusOptions = {
  __typename?: 'GetAllStatusOptions';
  /** List of all status options from status workflow */
  data?: Maybe<Scalars['Json']['output']>;
};

/** Get single case response */
export type GetCase = {
  __typename?: 'GetCase';
  /** Case data */
  data?: Maybe<Scalars['Json']['output']>;
};

/** Get case attachments response */
export type GetCaseAttachments = {
  __typename?: 'GetCaseAttachments';
  /** List of case attachments */
  data?: Maybe<Scalars['Json']['output']>;
};

/** Get case comments response */
export type GetCaseComments = {
  __typename?: 'GetCaseComments';
  /** List of case comments */
  data?: Maybe<Scalars['Json']['output']>;
};

/** Get case details basic response (without comments and tasks) */
export type GetCaseDetailsBasic = {
  __typename?: 'GetCaseDetailsBasic';
  /** Basic case details data */
  data?: Maybe<Scalars['Json']['output']>;
};

/** Get case fields response */
export type GetCaseFields = {
  __typename?: 'GetCaseFields';
  /** Case field definitions */
  data?: Maybe<Scalars['Json']['output']>;
};

/** Get full case details response */
export type GetCaseFull = {
  __typename?: 'GetCaseFull';
  /** Full case data with all related entities */
  data?: Maybe<Scalars['Json']['output']>;
};

/** Get case history response */
export type GetCaseHistory = {
  __typename?: 'GetCaseHistory';
  /** Case history/audit trail */
  data?: Maybe<Scalars['Json']['output']>;
};

/** Case priorities response */
export type GetCasePriorities = {
  __typename?: 'GetCasePriorities';
  /** List of case priorities */
  data?: Maybe<Scalars['Json']['output']>;
};

/** Get case tasks response */
export type GetCaseTasks = {
  __typename?: 'GetCaseTasks';
  /** List of case tasks */
  data?: Maybe<Scalars['Json']['output']>;
};

/** Case type fields response */
export type GetCaseTypeFields = {
  __typename?: 'GetCaseTypeFields';
  /** Case type field definitions */
  data?: Maybe<Scalars['Json']['output']>;
};

/** Case types response */
export type GetCaseTypes = {
  __typename?: 'GetCaseTypes';
  /** List of case types with pagination */
  data?: Maybe<Scalars['Json']['output']>;
};

/** Get case workflow response */
export type GetCaseWorkflow = {
  __typename?: 'GetCaseWorkflow';
  /** Case workflow state and available transitions */
  data?: Maybe<Scalars['Json']['output']>;
};

/** Get cases advanced search response */
export type GetCasesAdvancedSearch = {
  __typename?: 'GetCasesAdvancedSearch';
  /** List of cases matching advanced query */
  data?: Maybe<Scalars['Json']['output']>;
};

/** Get cases list response */
export type GetCasesList = {
  __typename?: 'GetCasesList';
  /** Column ordering for display */
  columnOrder?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Paginated list of cases */
  data?: Maybe<Scalars['Json']['output']>;
  /** Pagination metadata including total count and page info */
  pagination?: Maybe<Scalars['Json']['output']>;
  /** Total number of cases matching the query */
  total?: Maybe<Scalars['Int']['output']>;
};

/** Commands response */
export type GetCommands = {
  __typename?: 'GetCommands';
  /** List of available commands with their parameters and metadata */
  data?: Maybe<Scalars['Json']['output']>;
};

/** Get Devo Alert Details data */
export type GetDevoAlertDetails = {
  __typename?: 'GetDevoAlertDetails';
  /** Detailed Devo alert information */
  data?: Maybe<Scalars['Json']['output']>;
};

/** Get Devo Alert Query Interval data */
export type GetDevoAlertQueryInterval = {
  __typename?: 'GetDevoAlertQueryInterval';
  /** Query interval (from/to dates) for Devo alert */
  data?: Maybe<Scalars['Json']['output']>;
};

/** Get Devo case alerts response */
export type GetDevoCaseAlerts = {
  __typename?: 'GetDevoCaseAlerts';
  /** List of Devo case alerts with pagination */
  data?: Maybe<Scalars['Json']['output']>;
};

/** Get Grouped Devo Case Alerts data */
export type GetDevoCaseAlertsGrouped = {
  __typename?: 'GetDevoCaseAlertsGrouped';
  /** List of Devo alert groups with pagination */
  data?: Maybe<Scalars['Json']['output']>;
};

/** SOAR domains response */
export type GetDomains = {
  __typename?: 'GetDomains';
  /** Domains data from SOAR API */
  data?: Maybe<Scalars['Json']['output']>;
};

/** Get field definitions response */
export type GetFieldDefinitions = {
  __typename?: 'GetFieldDefinitions';
  /** List of field definitions with pagination */
  data?: Maybe<Scalars['Json']['output']>;
};

/** Integrations response */
export type GetIntegrations = {
  __typename?: 'GetIntegrations';
  /** List of available integration commands with their connections and actions */
  data?: Maybe<Scalars['Json']['output']>;
};

/** Get linked cases response */
export type GetLinkedCases = {
  __typename?: 'GetLinkedCases';
  /** List of linked cases with case objects and similarity information */
  data?: Maybe<Scalars['Json']['output']>;
};

/** Get saved searches response */
export type GetSavedSearches = {
  __typename?: 'GetSavedSearches';
  /** Saved searches data containing array of search objects with totalSize */
  data?: Maybe<Scalars['Json']['output']>;
};

/** Get similar cases response */
export type GetSimilarCases = {
  __typename?: 'GetSimilarCases';
  /** List of similar cases with similarity scores */
  data?: Maybe<Scalars['Json']['output']>;
};

/** Get SOAR Alert Detail data */
export type GetSoarAlert = {
  __typename?: 'GetSoarAlert';
  /** Additional alert fields */
  additionalFields?: Maybe<Scalars['Json']['output']>;
  /** Alert source information */
  alertSource?: Maybe<SoarAlertSource>;
  /** Type of alert */
  alertType?: Maybe<Scalars['String']['output']>;
  /** Alert comments */
  comments?: Maybe<Scalars['Json']['output']>;
  /** Alert creation timestamp */
  createdAt?: Maybe<Scalars['String']['output']>;
  /** Alert description */
  description?: Maybe<Scalars['String']['output']>;
  /** Alert history */
  history?: Maybe<Scalars['Json']['output']>;
  /** Alert ID */
  id?: Maybe<Scalars['String']['output']>;
  /** Mapped field values */
  mappedAlertFieldValues?: Maybe<Array<Maybe<SoarMappedField>>>;
  /** Alert name */
  name?: Maybe<Scalars['String']['output']>;
};

/** Get SOAR Alerts Advanced Search data */
export type GetSoarAlertsAdvanced = {
  __typename?: 'GetSoarAlertsAdvanced';
  /** List of SOAR alerts */
  alerts?: Maybe<Array<Maybe<SoarAlert>>>;
  /** The query that was executed */
  query?: Maybe<Scalars['String']['output']>;
  /** Total number of alerts matching the query */
  totalSize?: Maybe<Scalars['Int']['output']>;
};

/** Get task form response */
export type GetTaskForm = {
  __typename?: 'GetTaskForm';
  /** Form definition data */
  data?: Maybe<Scalars['Json']['output']>;
  /** Form ID */
  id?: Maybe<Scalars['String']['output']>;
  /** Form name */
  name?: Maybe<Scalars['String']['output']>;
};

/** User details response */
export type GetUser = {
  __typename?: 'GetUser';
  /** User details */
  data?: Maybe<Scalars['Json']['output']>;
};

/** User forms response */
export type GetUserForms = {
  __typename?: 'GetUserForms';
  /** User forms data with pagination information */
  data?: Maybe<Scalars['Json']['output']>;
};

/** User groups response */
export type GetUserGroups = {
  __typename?: 'GetUserGroups';
  /** List of user groups */
  data?: Maybe<Scalars['Json']['output']>;
};

/** Users list response */
export type GetUsers = {
  __typename?: 'GetUsers';
  /** List of users */
  data?: Maybe<Scalars['Json']['output']>;
};

/** Vector config response */
export type GetVectorConfig = {
  __typename?: 'GetVectorConfig';
  /** Full vector config from the routing API */
  data?: Maybe<Scalars['Json']['output']>;
};

/** Vector destinations response */
export type GetVectorDestinations = {
  __typename?: 'GetVectorDestinations';
  /** List of vector destinations from the routing API */
  data?: Maybe<Scalars['Json']['output']>;
};

/** Vector rules response */
export type GetVectorRules = {
  __typename?: 'GetVectorRules';
  /** List of vector routing rules from the routing API */
  data?: Maybe<Scalars['Json']['output']>;
};

/** Vector sources response */
export type GetVectorSources = {
  __typename?: 'GetVectorSources';
  /** List of vector sources from the routing API */
  data?: Maybe<Scalars['Json']['output']>;
};

/** Link cases response */
export type LinkCases = {
  __typename?: 'LinkCases';
  /** Link operation result */
  data?: Maybe<Scalars['Json']['output']>;
};

/** Post comment response */
export type PostComment = {
  __typename?: 'PostComment';
  /** Created comment data */
  data?: Maybe<Scalars['Json']['output']>;
};

export type PostCommentInput = {
  /** Comment text */
  comment: Scalars['String']['input'];
  /** User name posting the comment */
  userName: Scalars['String']['input'];
};

export type RootMutationType = {
  __typename?: 'RootMutationType';
  /** Create a new case */
  createCase?: Maybe<CreateCase>;
  /** Create a case directly */
  createCaseDirect?: Maybe<CreateCase>;
  /** Create a case via SOAR API (simplified input) */
  createCaseSoar?: Maybe<CreateCase>;
  /** Create a saved search */
  createSavedSearch?: Maybe<CreateSavedSearch>;
  /** Create a new vector destination */
  createVectorDestination?: Maybe<CreateVectorDestination>;
  /** Create a new vector rule */
  createVectorRule?: Maybe<CreateVectorRule>;
  /** Create a new vector source */
  createVectorSource?: Maybe<CreateVectorSource>;
  /** Delete an attachment */
  deleteAttachment?: Maybe<DeleteAttachment>;
  /** Delete a case */
  deleteCase?: Maybe<DeleteCase>;
  /** Delete multiple cases */
  deleteCases?: Maybe<DeleteCases>;
  /** Delete a comment */
  deleteComment?: Maybe<DeleteComment>;
  /** Delete a saved search */
  deleteSavedSearch?: Maybe<DeleteSavedSearch>;
  /** Delete a vector destination */
  deleteVectorDestination?: Maybe<DeleteVectorDestination>;
  /** Delete a vector rule */
  deleteVectorRule?: Maybe<DeleteVectorRule>;
  /** Delete a vector source */
  deleteVectorSource?: Maybe<DeleteVectorSource>;
  /** Link cases together */
  linkCases?: Maybe<LinkCases>;
  /** Post a comment on a case */
  postComment?: Maybe<PostComment>;
  /** Unlink cases */
  unlinkCases?: Maybe<UnlinkCases>;
  /** Unlink Devo alerts from a case */
  unlinkDevoAlertsFromCase?: Maybe<UnlinkDevoAlertsFromCase>;
  /** Update an existing case */
  updateCase?: Maybe<UpdateCase>;
  /** Update a case via SOAR API (simplified input) */
  updateCaseSoar?: Maybe<UpdateCase>;
  /** Update a comment */
  updateComment?: Maybe<UpdateComment>;
  /** Update a saved search */
  updateSavedSearch?: Maybe<UpdateSavedSearch>;
  /** Update a task */
  updateTask?: Maybe<UpdateTask>;
  /** Update an existing vector rule */
  updateVectorRule?: Maybe<UpdateVectorRule>;
  /** Upload an attachment */
  uploadAttachment?: Maybe<UploadAttachment>;
};


export type RootMutationTypeCreateCaseArgs = {
  input: CreateCaseInput;
  xDevoDomain?: InputMaybe<Scalars['String']['input']>;
};


export type RootMutationTypeCreateCaseDirectArgs = {
  input: CreateCaseDirectInput;
  xDevoDomain?: InputMaybe<Scalars['String']['input']>;
};


export type RootMutationTypeCreateCaseSoarArgs = {
  input: CreateCaseInputSoar;
  xDevoDomain?: InputMaybe<Scalars['String']['input']>;
};


export type RootMutationTypeCreateSavedSearchArgs = {
  input: CreateSavedSearchInput;
  xDevoDomain?: InputMaybe<Scalars['String']['input']>;
};


export type RootMutationTypeCreateVectorDestinationArgs = {
  input: CreateVectorDestinationInput;
};


export type RootMutationTypeCreateVectorRuleArgs = {
  input: CreateVectorRuleInput;
};


export type RootMutationTypeCreateVectorSourceArgs = {
  input: CreateVectorSourceInput;
};


export type RootMutationTypeDeleteAttachmentArgs = {
  attachmentId: Scalars['String']['input'];
  xDevoDomain?: InputMaybe<Scalars['String']['input']>;
};


export type RootMutationTypeDeleteCaseArgs = {
  caseId: Scalars['String']['input'];
  xDevoDomain?: InputMaybe<Scalars['String']['input']>;
};


export type RootMutationTypeDeleteCasesArgs = {
  caseIds: Array<Scalars['String']['input']>;
  xDevoDomain?: InputMaybe<Scalars['String']['input']>;
};


export type RootMutationTypeDeleteCommentArgs = {
  commentId: Scalars['String']['input'];
  xDevoDomain?: InputMaybe<Scalars['String']['input']>;
};


export type RootMutationTypeDeleteSavedSearchArgs = {
  searchId: Scalars['String']['input'];
  xDevoDomain?: InputMaybe<Scalars['String']['input']>;
};


export type RootMutationTypeDeleteVectorDestinationArgs = {
  name: Scalars['String']['input'];
};


export type RootMutationTypeDeleteVectorRuleArgs = {
  name: Scalars['String']['input'];
};


export type RootMutationTypeDeleteVectorSourceArgs = {
  name: Scalars['String']['input'];
};


export type RootMutationTypeLinkCasesArgs = {
  caseId: Scalars['String']['input'];
  linkCaseIds: Array<Scalars['String']['input']>;
  xDevoDomain?: InputMaybe<Scalars['String']['input']>;
};


export type RootMutationTypePostCommentArgs = {
  caseId: Scalars['String']['input'];
  input: PostCommentInput;
  xDevoDomain?: InputMaybe<Scalars['String']['input']>;
};


export type RootMutationTypeUnlinkCasesArgs = {
  caseId: Scalars['String']['input'];
  unlinkCaseIds: Array<Scalars['String']['input']>;
  xDevoDomain?: InputMaybe<Scalars['String']['input']>;
};


export type RootMutationTypeUnlinkDevoAlertsFromCaseArgs = {
  alertIds: Array<Scalars['String']['input']>;
  caseId: Scalars['String']['input'];
  xDevoDomain?: InputMaybe<Scalars['String']['input']>;
};


export type RootMutationTypeUpdateCaseArgs = {
  id: Scalars['String']['input'];
  input: UpdateCaseInput;
  xDevoDomain?: InputMaybe<Scalars['String']['input']>;
};


export type RootMutationTypeUpdateCaseSoarArgs = {
  id: Scalars['String']['input'];
  input: UpdateCaseInputSoar;
  xDevoDomain?: InputMaybe<Scalars['String']['input']>;
};


export type RootMutationTypeUpdateCommentArgs = {
  commentId: Scalars['String']['input'];
  input: UpdateCommentInput;
  xDevoDomain?: InputMaybe<Scalars['String']['input']>;
};


export type RootMutationTypeUpdateSavedSearchArgs = {
  input: UpdateSavedSearchInput;
  searchId: Scalars['String']['input'];
  xDevoDomain?: InputMaybe<Scalars['String']['input']>;
};


export type RootMutationTypeUpdateTaskArgs = {
  id: Scalars['String']['input'];
  input: UpdateTaskInput;
  xDevoDomain?: InputMaybe<Scalars['String']['input']>;
};


export type RootMutationTypeUpdateVectorRuleArgs = {
  input: UpdateVectorRuleInput;
  name: Scalars['String']['input'];
};


export type RootMutationTypeUploadAttachmentArgs = {
  input: UploadAttachmentInput;
  xDevoDomain?: InputMaybe<Scalars['String']['input']>;
};

export type RootQueryType = {
  __typename?: 'RootQueryType';
  /** Check delete permissions for given case IDs */
  checkCaseDeletePermissions?: Maybe<CheckCaseDeletePermissions>;
  /** Convert basic search filters to advanced query format */
  convertToAdvancedQuery?: Maybe<ConvertToAdvancedQuery>;
  /** Download an attachment */
  downloadAttachment?: Maybe<DownloadAttachment>;
  /** Download cases data as CSV */
  downloadCasesCsv?: Maybe<DownloadCasesCsv>;
  /** Execute Devo histogram query and return raw JSON */
  executeHistogram?: Maybe<Scalars['Json']['output']>;
  /** Execute Devo search query and return raw JSON */
  executeSearch?: Maybe<Scalars['Json']['output']>;
  /** Get all status options from status workflow */
  getAllStatusOptions?: Maybe<GetAllStatusOptions>;
  /** Get a specific case by ID */
  getCase?: Maybe<GetCase>;
  /** Get case attachments */
  getCaseAttachments?: Maybe<GetCaseAttachments>;
  /** Get case comments */
  getCaseComments?: Maybe<GetCaseComments>;
  /** Get case details without comments and tasks */
  getCaseDetailsBasic?: Maybe<GetCaseDetailsBasic>;
  /** Get fields for a specific case */
  getCaseFields?: Maybe<GetCaseFields>;
  /** Get full case details with comments and tasks */
  getCaseFull?: Maybe<GetCaseFull>;
  /** Get case history */
  getCaseHistory?: Maybe<GetCaseHistory>;
  /** Get case priorities */
  getCasePriorities?: Maybe<GetCasePriorities>;
  /** Get case tasks */
  getCaseTasks?: Maybe<GetCaseTasks>;
  /** Get case type fields */
  getCaseTypeFields?: Maybe<GetCaseTypeFields>;
  /** Get case types */
  getCaseTypes?: Maybe<GetCaseTypes>;
  /** Get case workflow */
  getCaseWorkflow?: Maybe<GetCaseWorkflow>;
  /** Get cases using advanced query search */
  getCasesAdvancedSearch?: Maybe<GetCasesAdvancedSearch>;
  /** Get cases list with filtering and pagination */
  getCasesList?: Maybe<GetCasesList>;
  /** Get available commands with their parameters and metadata */
  getCommands?: Maybe<GetCommands>;
  /** Get Devo alert details */
  getDevoAlertDetails?: Maybe<GetDevoAlertDetails>;
  /** Get Devo alert query interval */
  getDevoAlertQueryInterval?: Maybe<GetDevoAlertQueryInterval>;
  /** Get Devo case alerts */
  getDevoCaseAlerts?: Maybe<GetDevoCaseAlerts>;
  /** Get grouped Devo alerts for a specific case by ID with pagination */
  getDevoCaseAlertsGrouped?: Maybe<GetDevoCaseAlertsGrouped>;
  /** Get SOAR domains list */
  getDomains?: Maybe<GetDomains>;
  /** Get all field definitions */
  getFieldDefinitions?: Maybe<GetFieldDefinitions>;
  /** Get available integrations with their connections and actions */
  getIntegrations?: Maybe<GetIntegrations>;
  /** Get linked cases */
  getLinkedCases?: Maybe<GetLinkedCases>;
  /** Get saved searches */
  getSavedSearches?: Maybe<GetSavedSearches>;
  /** Get similar cases */
  getSimilarCases?: Maybe<GetSimilarCases>;
  /** Get a single SOAR alert by ID */
  getSoarAlert?: Maybe<GetSoarAlert>;
  /** Get SOAR alerts using advanced search */
  getSoarAlertsAdvanced?: Maybe<GetSoarAlertsAdvanced>;
  /** Get task form */
  getTaskForm?: Maybe<GetTaskForm>;
  /** Get a specific user by ID */
  getUser?: Maybe<GetUser>;
  /** Get user forms with pagination */
  getUserForms?: Maybe<GetUserForms>;
  /** Get user groups */
  getUserGroups?: Maybe<GetUserGroups>;
  /** Get all users */
  getUsers?: Maybe<GetUsers>;
  /** Get the full vector config */
  getVectorConfig?: Maybe<GetVectorConfig>;
  /** Get all vector destinations */
  getVectorDestinations?: Maybe<GetVectorDestinations>;
  /** Get all vector routing rules */
  getVectorRules?: Maybe<GetVectorRules>;
  /** Get all vector sources */
  getVectorSources?: Maybe<GetVectorSources>;
  /** Health check query */
  health: Scalars['String']['output'];
  /** List all cases (simple wrapper for get_cases_list) */
  listCases?: Maybe<GetCasesList>;
  /** Search across cases and related data */
  search?: Maybe<SearchResults>;
  /** Get table signature from Devo */
  tableSignature?: Maybe<Scalars['Json']['output']>;
};


export type RootQueryTypeCheckCaseDeletePermissionsArgs = {
  caseIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  xDevoDomain?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeConvertToAdvancedQueryArgs = {
  assignee?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  caseTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  priority?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  text?: InputMaybe<Scalars['String']['input']>;
  types?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  xDevoDomain?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeDownloadAttachmentArgs = {
  attachmentUrl: Scalars['String']['input'];
  xDevoDomain?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeDownloadCasesCsvArgs = {
  input: DownloadCasesCsvInput;
  xDevoDomain?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeExecuteHistogramArgs = {
  from: Scalars['String']['input'];
  query: Scalars['String']['input'];
  timeGap?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
};


export type RootQueryTypeExecuteSearchArgs = {
  from: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  query: Scalars['String']['input'];
  to: Scalars['String']['input'];
};


export type RootQueryTypeGetAllStatusOptionsArgs = {
  domainIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  xDevoDomain?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeGetCaseArgs = {
  caseId: Scalars['String']['input'];
  xDevoDomain?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeGetCaseAttachmentsArgs = {
  caseId: Scalars['String']['input'];
  xDevoDomain?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeGetCaseCommentsArgs = {
  caseId: Scalars['String']['input'];
  xDevoDomain?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeGetCaseDetailsBasicArgs = {
  caseId: Scalars['String']['input'];
  xDevoDomain?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeGetCaseFieldsArgs = {
  caseId: Scalars['String']['input'];
  xDevoDomain?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeGetCaseFullArgs = {
  id: Scalars['String']['input'];
  xDevoDomain?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeGetCaseHistoryArgs = {
  caseId: Scalars['String']['input'];
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  xDevoDomain?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeGetCasePrioritiesArgs = {
  domainIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  xDevoDomain?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeGetCaseTasksArgs = {
  caseId: Scalars['String']['input'];
  xDevoDomain?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeGetCaseTypeFieldsArgs = {
  caseType: Scalars['String']['input'];
};


export type RootQueryTypeGetCaseTypesArgs = {
  after?: InputMaybe<Scalars['Int']['input']>;
  domainIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  excludeDeprecated?: InputMaybe<Scalars['Boolean']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  xDevoDomain?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeGetCaseWorkflowArgs = {
  caseId: Scalars['String']['input'];
  xDevoDomain?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeGetCasesAdvancedSearchArgs = {
  domainIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  includeTaskEntityType?: InputMaybe<Scalars['Boolean']['input']>;
  includeWorkflow?: InputMaybe<Scalars['Boolean']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  query: Scalars['String']['input'];
  sortCol?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
  xDevoDomain?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeGetCasesListArgs = {
  assignee?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  caseTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  domainIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  includeTaskEntityType?: InputMaybe<Scalars['Boolean']['input']>;
  includeWorkflow?: InputMaybe<Scalars['Boolean']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  priority?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sortCol?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  text?: InputMaybe<Scalars['String']['input']>;
  types?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  xDevoDomain?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeGetCommandsArgs = {
  xDevoDomain?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeGetDevoAlertDetailsArgs = {
  alertId: Scalars['String']['input'];
  timezone?: InputMaybe<Scalars['String']['input']>;
  xDevoDomain?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeGetDevoAlertQueryIntervalArgs = {
  alertId: Scalars['String']['input'];
  xDevoDomain?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeGetDevoCaseAlertsArgs = {
  caseId: Scalars['String']['input'];
  groupName?: InputMaybe<Scalars['String']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  xDevoDomain?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeGetDevoCaseAlertsGroupedArgs = {
  caseId: Scalars['String']['input'];
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  xDevoDomain?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeGetFieldDefinitionsArgs = {
  after?: InputMaybe<Scalars['Int']['input']>;
  domainIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  systemFields?: InputMaybe<Scalars['Boolean']['input']>;
  xDevoDomain?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeGetIntegrationsArgs = {
  xDevoDomain?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeGetLinkedCasesArgs = {
  caseId: Scalars['String']['input'];
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  xDevoDomain?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeGetSavedSearchesArgs = {
  after?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  xDevoDomain?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeGetSimilarCasesArgs = {
  caseId: Scalars['String']['input'];
  filterFields?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  minimumMatches?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortFieldName?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
  xDevoDomain?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeGetSoarAlertArgs = {
  alertId: Scalars['String']['input'];
};


export type RootQueryTypeGetSoarAlertsAdvancedArgs = {
  caseId?: InputMaybe<Scalars['String']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sortCol?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeGetTaskFormArgs = {
  taskId: Scalars['String']['input'];
  xDevoDomain?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeGetUserArgs = {
  userId: Scalars['String']['input'];
};


export type RootQueryTypeGetUserFormsArgs = {
  after?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  xDevoDomain?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeListCasesArgs = {
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  xDevoDomain?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeSearchArgs = {
  filter?: InputMaybe<SearchFilterInput>;
  query: Scalars['String']['input'];
};


export type RootQueryTypeTableSignatureArgs = {
  signature: Scalars['String']['input'];
};

export type SearchFilterInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  priority?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

/** Search results response */
export type SearchResults = {
  __typename?: 'SearchResults';
  /** List of matching cases */
  cases?: Maybe<Array<Maybe<Case>>>;
  /** The search query used */
  query?: Maybe<Scalars['String']['output']>;
  /** Total number of results */
  total?: Maybe<Scalars['Int']['output']>;
};

/** SOAR Alert object */
export type SoarAlert = {
  __typename?: 'SoarAlert';
  /** Alert source information */
  alertSource?: Maybe<SoarAlertSource>;
  /** Type of alert */
  alertType?: Maybe<Scalars['String']['output']>;
  /** Alert creation timestamp */
  createdAt?: Maybe<Scalars['String']['output']>;
  /** Alert description */
  description?: Maybe<Scalars['String']['output']>;
  /** Alert ID */
  id?: Maybe<Scalars['String']['output']>;
  /** Mapped field values */
  mappedAlertFieldValues?: Maybe<Array<Maybe<SoarMappedField>>>;
  /** Alert name */
  name?: Maybe<Scalars['String']['output']>;
};

/** SOAR Alert Source object */
export type SoarAlertSource = {
  __typename?: 'SoarAlertSource';
  /** Nested alert source information */
  alertSource?: Maybe<SoarNestedAlertSource>;
  /** Alert source ID */
  id?: Maybe<Scalars['String']['output']>;
};

/** SOAR Mapped Field object */
export type SoarMappedField = {
  __typename?: 'SoarMappedField';
  /** Case field ID */
  caseFieldId?: Maybe<Scalars['String']['output']>;
  /** Display name of the field */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Field name */
  fieldName?: Maybe<Scalars['String']['output']>;
  /** Field type */
  fieldType?: Maybe<Scalars['String']['output']>;
  /** Field value */
  value?: Maybe<Scalars['String']['output']>;
};

/** SOAR Nested Alert Source object */
export type SoarNestedAlertSource = {
  __typename?: 'SoarNestedAlertSource';
  /** Alert source object data */
  obj?: Maybe<Scalars['Json']['output']>;
  /** Alert source type */
  type?: Maybe<Scalars['String']['output']>;
};

/** Unlink cases response */
export type UnlinkCases = {
  __typename?: 'UnlinkCases';
  /** Unlink operation result */
  data?: Maybe<Scalars['Json']['output']>;
};

/** Unlink Devo Alerts from Case response */
export type UnlinkDevoAlertsFromCase = {
  __typename?: 'UnlinkDevoAlertsFromCase';
  /** Result of unlinking Devo alerts from case operation */
  data?: Maybe<Scalars['Json']['output']>;
};

/** Update case response */
export type UpdateCase = {
  __typename?: 'UpdateCase';
  /** Updated case data */
  data?: Maybe<Scalars['Json']['output']>;
};

/** Input for updating a case */
export type UpdateCaseInput = {
  /** Assigned user name */
  assigneeUserName?: InputMaybe<Scalars['String']['input']>;
  /** Case description */
  descriptionRaw?: InputMaybe<Scalars['String']['input']>;
  /** List of fields to update */
  fields?: InputMaybe<Array<FieldUpdateInput>>;
  /** Case priority */
  priority?: InputMaybe<Scalars['String']['input']>;
  /** Case status */
  status?: InputMaybe<Scalars['String']['input']>;
  /** Case title */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Simplified input for updating a case via SOAR API */
export type UpdateCaseInputSoar = {
  /** Case description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Case priority */
  priority?: InputMaybe<Scalars['String']['input']>;
  /** Case status */
  status?: InputMaybe<Scalars['String']['input']>;
  /** Case title */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Update comment response */
export type UpdateComment = {
  __typename?: 'UpdateComment';
  /** Updated comment data */
  data?: Maybe<Scalars['Json']['output']>;
};

export type UpdateCommentInput = {
  /** Updated comment text */
  comment: Scalars['String']['input'];
};

/** Update saved search response */
export type UpdateSavedSearch = {
  __typename?: 'UpdateSavedSearch';
  /** Updated saved search data */
  data?: Maybe<Scalars['Json']['output']>;
};

export type UpdateSavedSearchInput = {
  /** New name of the saved search */
  name?: InputMaybe<Scalars['String']['input']>;
  /** New query string for the search */
  query?: InputMaybe<Scalars['String']['input']>;
  /** New type of query - either 'basic' or 'advanced' */
  queryType?: InputMaybe<Scalars['String']['input']>;
};

/** Update task response */
export type UpdateTask = {
  __typename?: 'UpdateTask';
  /** Updated task data */
  data?: Maybe<Scalars['Json']['output']>;
};

/** Input for updating a task */
export type UpdateTaskInput = {
  /** Assigned user name */
  assigneeUserName?: InputMaybe<Scalars['String']['input']>;
  /** Task description */
  descriptionRaw?: InputMaybe<Scalars['String']['input']>;
  /** Form response data */
  formResponse?: InputMaybe<Scalars['String']['input']>;
  /** Task priority */
  priority?: InputMaybe<Scalars['String']['input']>;
  /** Task status */
  status?: InputMaybe<Scalars['String']['input']>;
};

/** Update vector rule response */
export type UpdateVectorRule = {
  __typename?: 'UpdateVectorRule';
  /** Updated vector rule data */
  data?: Maybe<Scalars['Json']['output']>;
};

/** Input for updating a vector rule */
export type UpdateVectorRuleInput = {
  /** Route or Reject */
  action?: InputMaybe<Scalars['String']['input']>;
  /** Additional rule configuration as JSON */
  config?: InputMaybe<Scalars['Json']['input']>;
  /** Destination name for matched data */
  destination?: InputMaybe<Scalars['String']['input']>;
  /** Whether the rule is enabled */
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** RegEx pattern for log filtering */
  filterRegex?: InputMaybe<Scalars['String']['input']>;
  /** Order of rule evaluation (1 = first) */
  priority?: InputMaybe<Scalars['Int']['input']>;
  /** Source name this rule applies to */
  source?: InputMaybe<Scalars['String']['input']>;
  /** Status string for the external API (enabled/disabled) */
  status?: InputMaybe<Scalars['String']['input']>;
};

/** Upload attachment response */
export type UploadAttachment = {
  __typename?: 'UploadAttachment';
  /** Uploaded attachment metadata */
  data?: Maybe<Scalars['Json']['output']>;
};

/** Input for uploading an attachment */
export type UploadAttachmentInput = {
  /** The case ID to upload attachment for */
  caseId: Scalars['String']['input'];
  /** The content of the attachment (base64 encoded) */
  content: Scalars['String']['input'];
  /** The name of the attachment file */
  name: Scalars['String']['input'];
};

export type GetDomainsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDomainsQuery = { __typename?: 'RootQueryType', getDomains?: { __typename?: 'GetDomains', data?: any | null } | null };

export type GetCaseTypesQueryVariables = Exact<{
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['Int']['input']>;
  excludeDeprecated?: InputMaybe<Scalars['Boolean']['input']>;
  domainIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  xDevoDomain?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetCaseTypesQuery = { __typename?: 'RootQueryType', getCaseTypes?: { __typename?: 'GetCaseTypes', data?: any | null } | null };

export type GetCasePrioritiesQueryVariables = Exact<{
  domainIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  xDevoDomain?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetCasePrioritiesQuery = { __typename?: 'RootQueryType', getCasePriorities?: { __typename?: 'GetCasePriorities', data?: any | null } | null };

export type GetAllStatusOptionsQueryVariables = Exact<{
  domainIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  xDevoDomain?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetAllStatusOptionsQuery = { __typename?: 'RootQueryType', getAllStatusOptions?: { __typename?: 'GetAllStatusOptions', data?: any | null } | null };

export type GetIntegrationsQueryVariables = Exact<{
  xDevoDomain?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetIntegrationsQuery = { __typename?: 'RootQueryType', getIntegrations?: { __typename?: 'GetIntegrations', data?: any | null } | null };

export type GetCommandsQueryVariables = Exact<{
  xDevoDomain?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetCommandsQuery = { __typename?: 'RootQueryType', getCommands?: { __typename?: 'GetCommands', data?: any | null } | null };

export type GetUserFormsQueryVariables = Exact<{
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['Int']['input']>;
  xDevoDomain?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetUserFormsQuery = { __typename?: 'RootQueryType', getUserForms?: { __typename?: 'GetUserForms', data?: any | null } | null };

export type GetUserGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserGroupsQuery = { __typename?: 'RootQueryType', getUserGroups?: { __typename?: 'GetUserGroups', data?: any | null } | null };

export type GetCasesListQueryVariables = Exact<{
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  types?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  priority?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  assignee?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  text?: InputMaybe<Scalars['String']['input']>;
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  includeTaskEntityType?: InputMaybe<Scalars['Boolean']['input']>;
  includeWorkflow?: InputMaybe<Scalars['Boolean']['input']>;
  sortCol?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
  domainIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type GetCasesListQuery = { __typename?: 'RootQueryType', getCasesList?: { __typename?: 'GetCasesList', data?: any | null } | null };

export type GetCaseDetailsQueryVariables = Exact<{
  caseId: Scalars['String']['input'];
  xDevoDomain?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetCaseDetailsQuery = { __typename?: 'RootQueryType', getCaseDetailsBasic?: { __typename?: 'GetCaseDetailsBasic', data?: any | null } | null };

export type GetCaseQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetCaseQuery = { __typename?: 'RootQueryType', getCaseFull?: { __typename?: 'GetCaseFull', data?: any | null } | null };

export type GetCaseBasicQueryVariables = Exact<{
  caseId: Scalars['String']['input'];
}>;


export type GetCaseBasicQuery = { __typename?: 'RootQueryType', getCase?: { __typename?: 'GetCase', data?: any | null } | null };

export type CheckCaseDeletePermissionsQueryVariables = Exact<{
  caseIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type CheckCaseDeletePermissionsQuery = { __typename?: 'RootQueryType', checkCaseDeletePermissions?: { __typename?: 'CheckCaseDeletePermissions', data?: any | null } | null };

export type DownloadCasesCsvQueryVariables = Exact<{
  input: DownloadCasesCsvInput;
}>;


export type DownloadCasesCsvQuery = { __typename?: 'RootQueryType', downloadCasesCsv?: { __typename?: 'DownloadCasesCsv', data?: string | null } | null };

export type GetCaseHistoryQueryVariables = Exact<{
  caseId: Scalars['String']['input'];
  xDevoDomain?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetCaseHistoryQuery = { __typename?: 'RootQueryType', getCaseHistory?: { __typename?: 'GetCaseHistory', data?: any | null } | null };

export type GetDevoCaseAlertsQueryVariables = Exact<{
  caseId: Scalars['String']['input'];
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  groupName?: InputMaybe<Scalars['String']['input']>;
  xDevoDomain?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetDevoCaseAlertsQuery = { __typename?: 'RootQueryType', getDevoCaseAlerts?: { __typename?: 'GetDevoCaseAlerts', data?: any | null } | null };

export type GetDevoCaseAlertsGroupedQueryVariables = Exact<{
  caseId: Scalars['String']['input'];
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  xDevoDomain?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetDevoCaseAlertsGroupedQuery = { __typename?: 'RootQueryType', getDevoCaseAlertsGrouped?: { __typename?: 'GetDevoCaseAlertsGrouped', data?: any | null } | null };

export type GetDevoAlertDetailsQueryVariables = Exact<{
  alertId: Scalars['String']['input'];
  timezone?: InputMaybe<Scalars['String']['input']>;
  xDevoDomain?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetDevoAlertDetailsQuery = { __typename?: 'RootQueryType', getDevoAlertDetails?: { __typename?: 'GetDevoAlertDetails', data?: any | null } | null };

export type GetDevoAlertQueryIntervalQueryVariables = Exact<{
  alertId: Scalars['String']['input'];
  xDevoDomain?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetDevoAlertQueryIntervalQuery = { __typename?: 'RootQueryType', getDevoAlertQueryInterval?: { __typename?: 'GetDevoAlertQueryInterval', data?: any | null } | null };

export type GetSoarAlertsAdvancedQueryVariables = Exact<{
  caseId?: InputMaybe<Scalars['String']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sortCol?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetSoarAlertsAdvancedQuery = { __typename?: 'RootQueryType', getSoarAlertsAdvanced?: { __typename?: 'GetSoarAlertsAdvanced', totalSize?: number | null, query?: string | null, alerts?: Array<{ __typename?: 'SoarAlert', id?: string | null, name?: string | null, alertType?: string | null, createdAt?: string | null, description?: string | null, alertSource?: { __typename?: 'SoarAlertSource', id?: string | null, alertSource?: { __typename?: 'SoarNestedAlertSource', type?: string | null, obj?: any | null } | null } | null, mappedAlertFieldValues?: Array<{ __typename?: 'SoarMappedField', caseFieldId?: string | null, displayName?: string | null, fieldName?: string | null, fieldType?: string | null, value?: string | null } | null> | null } | null> | null } | null };

export type GetSoarAlertQueryVariables = Exact<{
  alertId: Scalars['String']['input'];
}>;


export type GetSoarAlertQuery = { __typename?: 'RootQueryType', getSoarAlert?: { __typename?: 'GetSoarAlert', id?: string | null, name?: string | null, description?: string | null, alertType?: string | null, createdAt?: string | null, additionalFields?: any | null, comments?: any | null, history?: any | null, alertSource?: { __typename?: 'SoarAlertSource', id?: string | null, alertSource?: { __typename?: 'SoarNestedAlertSource', type?: string | null, obj?: any | null } | null } | null, mappedAlertFieldValues?: Array<{ __typename?: 'SoarMappedField', caseFieldId?: string | null, displayName?: string | null, fieldName?: string | null, fieldType?: string | null, value?: string | null } | null> | null } | null };

export type GetCaseTypeFieldsQueryVariables = Exact<{
  caseType: Scalars['String']['input'];
}>;


export type GetCaseTypeFieldsQuery = { __typename?: 'RootQueryType', getCaseTypeFields?: { __typename?: 'GetCaseTypeFields', data?: any | null } | null };

export type GetFieldDefinitionsQueryVariables = Exact<{
  systemFields?: InputMaybe<Scalars['Boolean']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['Int']['input']>;
  domainIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type GetFieldDefinitionsQuery = { __typename?: 'RootQueryType', getFieldDefinitions?: { __typename?: 'GetFieldDefinitions', data?: any | null } | null };

export type GetCaseFieldsQueryVariables = Exact<{
  caseId: Scalars['String']['input'];
  xDevoDomain?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetCaseFieldsQuery = { __typename?: 'RootQueryType', getCaseFields?: { __typename?: 'GetCaseFields', data?: any | null } | null };

export type GetTaskFormQueryVariables = Exact<{
  taskId: Scalars['String']['input'];
  xDevoDomain?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetTaskFormQuery = { __typename?: 'RootQueryType', getTaskForm?: { __typename?: 'GetTaskForm', data?: any | null } | null };

export type DownloadAttachmentQueryVariables = Exact<{
  attachmentUrl: Scalars['String']['input'];
  xDevoDomain?: InputMaybe<Scalars['String']['input']>;
}>;


export type DownloadAttachmentQuery = { __typename?: 'RootQueryType', downloadAttachment?: { __typename?: 'DownloadAttachment', data?: any | null } | null };

export type GetSavedSearchesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSavedSearchesQuery = { __typename?: 'RootQueryType', getSavedSearches?: { __typename?: 'GetSavedSearches', data?: any | null } | null };

export type ConvertToAdvancedQueryQueryVariables = Exact<{
  text?: InputMaybe<Scalars['String']['input']>;
  types?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  priority?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  assignee?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  xDevoDomain?: InputMaybe<Scalars['String']['input']>;
}>;


export type ConvertToAdvancedQueryQuery = { __typename?: 'RootQueryType', convertToAdvancedQuery?: { __typename?: 'ConvertToAdvancedQuery', data?: any | null } | null };

export type GetCasesAdvancedSearchQueryVariables = Exact<{
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  query: Scalars['String']['input'];
  includeTaskEntityType?: InputMaybe<Scalars['Boolean']['input']>;
  includeWorkflow?: InputMaybe<Scalars['Boolean']['input']>;
  sortCol?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
  domainIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  xDevoDomain?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetCasesAdvancedSearchQuery = { __typename?: 'RootQueryType', getCasesAdvancedSearch?: { __typename?: 'GetCasesAdvancedSearch', data?: any | null } | null };

export type GetCaseCommentsQueryVariables = Exact<{
  caseId: Scalars['String']['input'];
  xDevoDomain?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetCaseCommentsQuery = { __typename?: 'RootQueryType', getCaseComments?: { __typename?: 'GetCaseComments', data?: any | null } | null };

export type GetCaseTasksQueryVariables = Exact<{
  caseId: Scalars['String']['input'];
  xDevoDomain?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetCaseTasksQuery = { __typename?: 'RootQueryType', getCaseTasks?: { __typename?: 'GetCaseTasks', data?: any | null } | null };

export type GetCaseWorkflowQueryVariables = Exact<{
  caseId: Scalars['String']['input'];
  xDevoDomain?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetCaseWorkflowQuery = { __typename?: 'RootQueryType', getCaseWorkflow?: { __typename?: 'GetCaseWorkflow', data?: any | null } | null };

export type GetCaseAttachmentsQueryVariables = Exact<{
  caseId: Scalars['String']['input'];
  xDevoDomain?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetCaseAttachmentsQuery = { __typename?: 'RootQueryType', getCaseAttachments?: { __typename?: 'GetCaseAttachments', data?: any | null } | null };

export type GetAlertDetailsQueryVariables = Exact<{
  alertId: Scalars['String']['input'];
  timezone?: InputMaybe<Scalars['String']['input']>;
  xDevoDomain?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetAlertDetailsQuery = { __typename?: 'RootQueryType', getDevoAlertDetails?: { __typename?: 'GetDevoAlertDetails', data?: any | null } | null };

export type GetAlertQueryIntervalQueryVariables = Exact<{
  alertId: Scalars['String']['input'];
  xDevoDomain?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetAlertQueryIntervalQuery = { __typename?: 'RootQueryType', getDevoAlertQueryInterval?: { __typename?: 'GetDevoAlertQueryInterval', data?: any | null } | null };

export type GetSimilarCasesQueryVariables = Exact<{
  caseId: Scalars['String']['input'];
  filterFields?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  minimumMatches?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortFieldName?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
  xDevoDomain?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetSimilarCasesQuery = { __typename?: 'RootQueryType', getSimilarCases?: { __typename?: 'GetSimilarCases', data?: any | null } | null };

export type GetLinkedCasesQueryVariables = Exact<{
  caseId: Scalars['String']['input'];
  xDevoDomain?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetLinkedCasesQuery = { __typename?: 'RootQueryType', getLinkedCases?: { __typename?: 'GetLinkedCases', data?: any | null } | null };

export type ExecuteSearchQueryVariables = Exact<{
  query: Scalars['String']['input'];
  from: Scalars['String']['input'];
  to: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ExecuteSearchQuery = { __typename?: 'RootQueryType', executeSearch?: any | null };

export type ExecuteHistogramQueryVariables = Exact<{
  query: Scalars['String']['input'];
  from: Scalars['String']['input'];
  to: Scalars['String']['input'];
  timeGap?: InputMaybe<Scalars['String']['input']>;
}>;


export type ExecuteHistogramQuery = { __typename?: 'RootQueryType', executeHistogram?: any | null };

export type TableSignatureQueryVariables = Exact<{
  signature: Scalars['String']['input'];
}>;


export type TableSignatureQuery = { __typename?: 'RootQueryType', tableSignature?: any | null };

export type PostCommentMutationVariables = Exact<{
  caseId: Scalars['String']['input'];
  input: PostCommentInput;
  xDevoDomain?: InputMaybe<Scalars['String']['input']>;
}>;


export type PostCommentMutation = { __typename?: 'RootMutationType', postComment?: { __typename?: 'PostComment', data?: any | null } | null };

export type DeleteCommentMutationVariables = Exact<{
  commentId: Scalars['String']['input'];
  xDevoDomain?: InputMaybe<Scalars['String']['input']>;
}>;


export type DeleteCommentMutation = { __typename?: 'RootMutationType', deleteComment?: { __typename?: 'DeleteComment', data?: any | null } | null };

export type UpdateCommentMutationVariables = Exact<{
  commentId: Scalars['String']['input'];
  input: UpdateCommentInput;
  xDevoDomain?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateCommentMutation = { __typename?: 'RootMutationType', updateComment?: { __typename?: 'UpdateComment', data?: any | null } | null };

export type CreateCaseMutationVariables = Exact<{
  input: CreateCaseInput;
  xDevoDomain?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateCaseMutation = { __typename?: 'RootMutationType', createCase?: { __typename?: 'CreateCase', data?: any | null } | null };

export type CreateCaseDirectMutationVariables = Exact<{
  input: CreateCaseDirectInput;
  xDevoDomain?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateCaseDirectMutation = { __typename?: 'RootMutationType', createCaseDirect?: { __typename?: 'CreateCase', data?: any | null } | null };

export type UpdateCaseMutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: UpdateCaseInput;
  xDevoDomain?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateCaseMutation = { __typename?: 'RootMutationType', updateCase?: { __typename?: 'UpdateCase', data?: any | null } | null };

export type DeleteCaseMutationVariables = Exact<{
  caseId: Scalars['String']['input'];
  xDevoDomain?: InputMaybe<Scalars['String']['input']>;
}>;


export type DeleteCaseMutation = { __typename?: 'RootMutationType', deleteCase?: { __typename?: 'DeleteCase', data?: any | null } | null };

export type DeleteCasesMutationVariables = Exact<{
  caseIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type DeleteCasesMutation = { __typename?: 'RootMutationType', deleteCases?: { __typename?: 'DeleteCases', data?: any | null } | null };

export type LinkCasesMutationVariables = Exact<{
  caseId: Scalars['String']['input'];
  linkCaseIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  xDevoDomain?: InputMaybe<Scalars['String']['input']>;
}>;


export type LinkCasesMutation = { __typename?: 'RootMutationType', linkCases?: { __typename?: 'LinkCases', data?: any | null } | null };

export type UnlinkCasesMutationVariables = Exact<{
  caseId: Scalars['String']['input'];
  unlinkCaseIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  xDevoDomain?: InputMaybe<Scalars['String']['input']>;
}>;


export type UnlinkCasesMutation = { __typename?: 'RootMutationType', unlinkCases?: { __typename?: 'UnlinkCases', data?: any | null } | null };

export type UpdateTaskMutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: UpdateTaskInput;
  xDevoDomain?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateTaskMutation = { __typename?: 'RootMutationType', updateTask?: { __typename?: 'UpdateTask', data?: any | null } | null };

export type UploadAttachmentMutationVariables = Exact<{
  input: UploadAttachmentInput;
  xDevoDomain?: InputMaybe<Scalars['String']['input']>;
}>;


export type UploadAttachmentMutation = { __typename?: 'RootMutationType', uploadAttachment?: { __typename?: 'UploadAttachment', data?: any | null } | null };

export type DeleteAttachmentMutationVariables = Exact<{
  attachmentId: Scalars['String']['input'];
  xDevoDomain?: InputMaybe<Scalars['String']['input']>;
}>;


export type DeleteAttachmentMutation = { __typename?: 'RootMutationType', deleteAttachment?: { __typename?: 'DeleteAttachment', data?: any | null } | null };

export type UnlinkAlertsFromCaseMutationVariables = Exact<{
  caseId: Scalars['String']['input'];
  alertIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  xDevoDomain?: InputMaybe<Scalars['String']['input']>;
}>;


export type UnlinkAlertsFromCaseMutation = { __typename?: 'RootMutationType', unlinkDevoAlertsFromCase?: { __typename?: 'UnlinkDevoAlertsFromCase', data?: any | null } | null };

export type CreateSavedSearchMutationVariables = Exact<{
  input: CreateSavedSearchInput;
}>;


export type CreateSavedSearchMutation = { __typename?: 'RootMutationType', createSavedSearch?: { __typename?: 'CreateSavedSearch', data?: any | null } | null };

export type DeleteSavedSearchMutationVariables = Exact<{
  searchId: Scalars['String']['input'];
}>;


export type DeleteSavedSearchMutation = { __typename?: 'RootMutationType', deleteSavedSearch?: { __typename?: 'DeleteSavedSearch', data?: any | null } | null };

export type UpdateSavedSearchMutationVariables = Exact<{
  searchId: Scalars['String']['input'];
  input: UpdateSavedSearchInput;
}>;


export type UpdateSavedSearchMutation = { __typename?: 'RootMutationType', updateSavedSearch?: { __typename?: 'UpdateSavedSearch', data?: any | null } | null };

export type GetCaseAlertsQueryVariables = Exact<{
  caseId: Scalars['String']['input'];
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  groupName?: InputMaybe<Scalars['String']['input']>;
  xDevoDomain?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetCaseAlertsQuery = { __typename?: 'RootQueryType', getDevoCaseAlerts?: { __typename?: 'GetDevoCaseAlerts', data?: any | null } | null };

export type GetCaseAlertsGroupedQueryVariables = Exact<{
  caseId: Scalars['String']['input'];
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  xDevoDomain?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetCaseAlertsGroupedQuery = { __typename?: 'RootQueryType', getDevoCaseAlertsGrouped?: { __typename?: 'GetDevoCaseAlertsGrouped', data?: any | null } | null };

export type GetVectorSourcesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetVectorSourcesQuery = { __typename?: 'RootQueryType', getVectorSources?: { __typename?: 'GetVectorSources', data?: any | null } | null };

export type GetVectorDestinationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetVectorDestinationsQuery = { __typename?: 'RootQueryType', getVectorDestinations?: { __typename?: 'GetVectorDestinations', data?: any | null } | null };

export type GetVectorRulesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetVectorRulesQuery = { __typename?: 'RootQueryType', getVectorRules?: { __typename?: 'GetVectorRules', data?: any | null } | null };

export type GetVectorConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type GetVectorConfigQuery = { __typename?: 'RootQueryType', getVectorConfig?: { __typename?: 'GetVectorConfig', data?: any | null } | null };

export type CreateVectorSourceMutationVariables = Exact<{
  input: CreateVectorSourceInput;
}>;


export type CreateVectorSourceMutation = { __typename?: 'RootMutationType', createVectorSource?: { __typename?: 'CreateVectorSource', data?: any | null } | null };

export type DeleteVectorSourceMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type DeleteVectorSourceMutation = { __typename?: 'RootMutationType', deleteVectorSource?: { __typename?: 'DeleteVectorSource', data?: any | null } | null };

export type CreateVectorDestinationMutationVariables = Exact<{
  input: CreateVectorDestinationInput;
}>;


export type CreateVectorDestinationMutation = { __typename?: 'RootMutationType', createVectorDestination?: { __typename?: 'CreateVectorDestination', data?: any | null } | null };

export type DeleteVectorDestinationMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type DeleteVectorDestinationMutation = { __typename?: 'RootMutationType', deleteVectorDestination?: { __typename?: 'DeleteVectorDestination', data?: any | null } | null };

export type CreateVectorRuleMutationVariables = Exact<{
  input: CreateVectorRuleInput;
}>;


export type CreateVectorRuleMutation = { __typename?: 'RootMutationType', createVectorRule?: { __typename?: 'CreateVectorRule', data?: any | null } | null };

export type UpdateVectorRuleMutationVariables = Exact<{
  name: Scalars['String']['input'];
  input: UpdateVectorRuleInput;
}>;


export type UpdateVectorRuleMutation = { __typename?: 'RootMutationType', updateVectorRule?: { __typename?: 'UpdateVectorRule', data?: any | null } | null };

export type DeleteVectorRuleMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type DeleteVectorRuleMutation = { __typename?: 'RootMutationType', deleteVectorRule?: { __typename?: 'DeleteVectorRule', data?: any | null } | null };


export const GetDomainsDocument = gql`
    query GetDomains @endpoint(name: asoc) {
  getDomains {
    data
  }
}
    `;

/**
 * __useGetDomainsQuery__
 *
 * To run a query within a React component, call `useGetDomainsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDomainsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDomainsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDomainsQuery(baseOptions?: Apollo.QueryHookOptions<GetDomainsQuery, GetDomainsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDomainsQuery, GetDomainsQueryVariables>(GetDomainsDocument, options);
      }
export function useGetDomainsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDomainsQuery, GetDomainsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDomainsQuery, GetDomainsQueryVariables>(GetDomainsDocument, options);
        }
// @ts-ignore
export function useGetDomainsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDomainsQuery, GetDomainsQueryVariables>): Apollo.UseSuspenseQueryResult<GetDomainsQuery, GetDomainsQueryVariables>;
export function useGetDomainsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDomainsQuery, GetDomainsQueryVariables>): Apollo.UseSuspenseQueryResult<GetDomainsQuery | undefined, GetDomainsQueryVariables>;
export function useGetDomainsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDomainsQuery, GetDomainsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDomainsQuery, GetDomainsQueryVariables>(GetDomainsDocument, options);
        }
export type GetDomainsQueryHookResult = ReturnType<typeof useGetDomainsQuery>;
export type GetDomainsLazyQueryHookResult = ReturnType<typeof useGetDomainsLazyQuery>;
export type GetDomainsSuspenseQueryHookResult = ReturnType<typeof useGetDomainsSuspenseQuery>;
export type GetDomainsQueryResult = Apollo.QueryResult<GetDomainsQuery, GetDomainsQueryVariables>;
export const GetCaseTypesDocument = gql`
    query GetCaseTypes($pageSize: Int, $after: Int, $excludeDeprecated: Boolean, $domainIds: [String!], $xDevoDomain: String) @endpoint(name: asoc) {
  getCaseTypes(
    pageSize: $pageSize
    after: $after
    excludeDeprecated: $excludeDeprecated
    domainIds: $domainIds
    xDevoDomain: $xDevoDomain
  ) {
    data
  }
}
    `;

/**
 * __useGetCaseTypesQuery__
 *
 * To run a query within a React component, call `useGetCaseTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCaseTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCaseTypesQuery({
 *   variables: {
 *      pageSize: // value for 'pageSize'
 *      after: // value for 'after'
 *      excludeDeprecated: // value for 'excludeDeprecated'
 *      domainIds: // value for 'domainIds'
 *      xDevoDomain: // value for 'xDevoDomain'
 *   },
 * });
 */
export function useGetCaseTypesQuery(baseOptions?: Apollo.QueryHookOptions<GetCaseTypesQuery, GetCaseTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCaseTypesQuery, GetCaseTypesQueryVariables>(GetCaseTypesDocument, options);
      }
export function useGetCaseTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCaseTypesQuery, GetCaseTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCaseTypesQuery, GetCaseTypesQueryVariables>(GetCaseTypesDocument, options);
        }
// @ts-ignore
export function useGetCaseTypesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCaseTypesQuery, GetCaseTypesQueryVariables>): Apollo.UseSuspenseQueryResult<GetCaseTypesQuery, GetCaseTypesQueryVariables>;
export function useGetCaseTypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCaseTypesQuery, GetCaseTypesQueryVariables>): Apollo.UseSuspenseQueryResult<GetCaseTypesQuery | undefined, GetCaseTypesQueryVariables>;
export function useGetCaseTypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCaseTypesQuery, GetCaseTypesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCaseTypesQuery, GetCaseTypesQueryVariables>(GetCaseTypesDocument, options);
        }
export type GetCaseTypesQueryHookResult = ReturnType<typeof useGetCaseTypesQuery>;
export type GetCaseTypesLazyQueryHookResult = ReturnType<typeof useGetCaseTypesLazyQuery>;
export type GetCaseTypesSuspenseQueryHookResult = ReturnType<typeof useGetCaseTypesSuspenseQuery>;
export type GetCaseTypesQueryResult = Apollo.QueryResult<GetCaseTypesQuery, GetCaseTypesQueryVariables>;
export const GetCasePrioritiesDocument = gql`
    query GetCasePriorities($domainIds: [String!], $xDevoDomain: String) @endpoint(name: asoc) {
  getCasePriorities(domainIds: $domainIds, xDevoDomain: $xDevoDomain) {
    data
  }
}
    `;

/**
 * __useGetCasePrioritiesQuery__
 *
 * To run a query within a React component, call `useGetCasePrioritiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCasePrioritiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCasePrioritiesQuery({
 *   variables: {
 *      domainIds: // value for 'domainIds'
 *      xDevoDomain: // value for 'xDevoDomain'
 *   },
 * });
 */
export function useGetCasePrioritiesQuery(baseOptions?: Apollo.QueryHookOptions<GetCasePrioritiesQuery, GetCasePrioritiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCasePrioritiesQuery, GetCasePrioritiesQueryVariables>(GetCasePrioritiesDocument, options);
      }
export function useGetCasePrioritiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCasePrioritiesQuery, GetCasePrioritiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCasePrioritiesQuery, GetCasePrioritiesQueryVariables>(GetCasePrioritiesDocument, options);
        }
// @ts-ignore
export function useGetCasePrioritiesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCasePrioritiesQuery, GetCasePrioritiesQueryVariables>): Apollo.UseSuspenseQueryResult<GetCasePrioritiesQuery, GetCasePrioritiesQueryVariables>;
export function useGetCasePrioritiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCasePrioritiesQuery, GetCasePrioritiesQueryVariables>): Apollo.UseSuspenseQueryResult<GetCasePrioritiesQuery | undefined, GetCasePrioritiesQueryVariables>;
export function useGetCasePrioritiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCasePrioritiesQuery, GetCasePrioritiesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCasePrioritiesQuery, GetCasePrioritiesQueryVariables>(GetCasePrioritiesDocument, options);
        }
export type GetCasePrioritiesQueryHookResult = ReturnType<typeof useGetCasePrioritiesQuery>;
export type GetCasePrioritiesLazyQueryHookResult = ReturnType<typeof useGetCasePrioritiesLazyQuery>;
export type GetCasePrioritiesSuspenseQueryHookResult = ReturnType<typeof useGetCasePrioritiesSuspenseQuery>;
export type GetCasePrioritiesQueryResult = Apollo.QueryResult<GetCasePrioritiesQuery, GetCasePrioritiesQueryVariables>;
export const GetAllStatusOptionsDocument = gql`
    query GetAllStatusOptions($domainIds: [String!], $xDevoDomain: String) @endpoint(name: asoc) {
  getAllStatusOptions(domainIds: $domainIds, xDevoDomain: $xDevoDomain) {
    data
  }
}
    `;

/**
 * __useGetAllStatusOptionsQuery__
 *
 * To run a query within a React component, call `useGetAllStatusOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllStatusOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllStatusOptionsQuery({
 *   variables: {
 *      domainIds: // value for 'domainIds'
 *      xDevoDomain: // value for 'xDevoDomain'
 *   },
 * });
 */
export function useGetAllStatusOptionsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllStatusOptionsQuery, GetAllStatusOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllStatusOptionsQuery, GetAllStatusOptionsQueryVariables>(GetAllStatusOptionsDocument, options);
      }
export function useGetAllStatusOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllStatusOptionsQuery, GetAllStatusOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllStatusOptionsQuery, GetAllStatusOptionsQueryVariables>(GetAllStatusOptionsDocument, options);
        }
// @ts-ignore
export function useGetAllStatusOptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllStatusOptionsQuery, GetAllStatusOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllStatusOptionsQuery, GetAllStatusOptionsQueryVariables>;
export function useGetAllStatusOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllStatusOptionsQuery, GetAllStatusOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllStatusOptionsQuery | undefined, GetAllStatusOptionsQueryVariables>;
export function useGetAllStatusOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllStatusOptionsQuery, GetAllStatusOptionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllStatusOptionsQuery, GetAllStatusOptionsQueryVariables>(GetAllStatusOptionsDocument, options);
        }
export type GetAllStatusOptionsQueryHookResult = ReturnType<typeof useGetAllStatusOptionsQuery>;
export type GetAllStatusOptionsLazyQueryHookResult = ReturnType<typeof useGetAllStatusOptionsLazyQuery>;
export type GetAllStatusOptionsSuspenseQueryHookResult = ReturnType<typeof useGetAllStatusOptionsSuspenseQuery>;
export type GetAllStatusOptionsQueryResult = Apollo.QueryResult<GetAllStatusOptionsQuery, GetAllStatusOptionsQueryVariables>;
export const GetIntegrationsDocument = gql`
    query GetIntegrations($xDevoDomain: String) @endpoint(name: asoc) {
  getIntegrations(xDevoDomain: $xDevoDomain) {
    data
  }
}
    `;

/**
 * __useGetIntegrationsQuery__
 *
 * To run a query within a React component, call `useGetIntegrationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIntegrationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIntegrationsQuery({
 *   variables: {
 *      xDevoDomain: // value for 'xDevoDomain'
 *   },
 * });
 */
export function useGetIntegrationsQuery(baseOptions?: Apollo.QueryHookOptions<GetIntegrationsQuery, GetIntegrationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIntegrationsQuery, GetIntegrationsQueryVariables>(GetIntegrationsDocument, options);
      }
export function useGetIntegrationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIntegrationsQuery, GetIntegrationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIntegrationsQuery, GetIntegrationsQueryVariables>(GetIntegrationsDocument, options);
        }
// @ts-ignore
export function useGetIntegrationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetIntegrationsQuery, GetIntegrationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetIntegrationsQuery, GetIntegrationsQueryVariables>;
export function useGetIntegrationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetIntegrationsQuery, GetIntegrationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetIntegrationsQuery | undefined, GetIntegrationsQueryVariables>;
export function useGetIntegrationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetIntegrationsQuery, GetIntegrationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetIntegrationsQuery, GetIntegrationsQueryVariables>(GetIntegrationsDocument, options);
        }
export type GetIntegrationsQueryHookResult = ReturnType<typeof useGetIntegrationsQuery>;
export type GetIntegrationsLazyQueryHookResult = ReturnType<typeof useGetIntegrationsLazyQuery>;
export type GetIntegrationsSuspenseQueryHookResult = ReturnType<typeof useGetIntegrationsSuspenseQuery>;
export type GetIntegrationsQueryResult = Apollo.QueryResult<GetIntegrationsQuery, GetIntegrationsQueryVariables>;
export const GetCommandsDocument = gql`
    query GetCommands($xDevoDomain: String) @endpoint(name: asoc) {
  getCommands(xDevoDomain: $xDevoDomain) {
    data
  }
}
    `;

/**
 * __useGetCommandsQuery__
 *
 * To run a query within a React component, call `useGetCommandsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommandsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommandsQuery({
 *   variables: {
 *      xDevoDomain: // value for 'xDevoDomain'
 *   },
 * });
 */
export function useGetCommandsQuery(baseOptions?: Apollo.QueryHookOptions<GetCommandsQuery, GetCommandsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCommandsQuery, GetCommandsQueryVariables>(GetCommandsDocument, options);
      }
export function useGetCommandsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCommandsQuery, GetCommandsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCommandsQuery, GetCommandsQueryVariables>(GetCommandsDocument, options);
        }
// @ts-ignore
export function useGetCommandsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCommandsQuery, GetCommandsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCommandsQuery, GetCommandsQueryVariables>;
export function useGetCommandsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCommandsQuery, GetCommandsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCommandsQuery | undefined, GetCommandsQueryVariables>;
export function useGetCommandsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCommandsQuery, GetCommandsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCommandsQuery, GetCommandsQueryVariables>(GetCommandsDocument, options);
        }
export type GetCommandsQueryHookResult = ReturnType<typeof useGetCommandsQuery>;
export type GetCommandsLazyQueryHookResult = ReturnType<typeof useGetCommandsLazyQuery>;
export type GetCommandsSuspenseQueryHookResult = ReturnType<typeof useGetCommandsSuspenseQuery>;
export type GetCommandsQueryResult = Apollo.QueryResult<GetCommandsQuery, GetCommandsQueryVariables>;
export const GetUserFormsDocument = gql`
    query GetUserForms($pageSize: Int, $after: Int, $xDevoDomain: String) @endpoint(name: asoc) {
  getUserForms(pageSize: $pageSize, after: $after, xDevoDomain: $xDevoDomain) {
    data
  }
}
    `;

/**
 * __useGetUserFormsQuery__
 *
 * To run a query within a React component, call `useGetUserFormsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserFormsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserFormsQuery({
 *   variables: {
 *      pageSize: // value for 'pageSize'
 *      after: // value for 'after'
 *      xDevoDomain: // value for 'xDevoDomain'
 *   },
 * });
 */
export function useGetUserFormsQuery(baseOptions?: Apollo.QueryHookOptions<GetUserFormsQuery, GetUserFormsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserFormsQuery, GetUserFormsQueryVariables>(GetUserFormsDocument, options);
      }
export function useGetUserFormsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserFormsQuery, GetUserFormsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserFormsQuery, GetUserFormsQueryVariables>(GetUserFormsDocument, options);
        }
// @ts-ignore
export function useGetUserFormsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserFormsQuery, GetUserFormsQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserFormsQuery, GetUserFormsQueryVariables>;
export function useGetUserFormsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserFormsQuery, GetUserFormsQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserFormsQuery | undefined, GetUserFormsQueryVariables>;
export function useGetUserFormsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserFormsQuery, GetUserFormsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserFormsQuery, GetUserFormsQueryVariables>(GetUserFormsDocument, options);
        }
export type GetUserFormsQueryHookResult = ReturnType<typeof useGetUserFormsQuery>;
export type GetUserFormsLazyQueryHookResult = ReturnType<typeof useGetUserFormsLazyQuery>;
export type GetUserFormsSuspenseQueryHookResult = ReturnType<typeof useGetUserFormsSuspenseQuery>;
export type GetUserFormsQueryResult = Apollo.QueryResult<GetUserFormsQuery, GetUserFormsQueryVariables>;
export const GetUserGroupsDocument = gql`
    query GetUserGroups @endpoint(name: asoc) {
  getUserGroups {
    data
  }
}
    `;

/**
 * __useGetUserGroupsQuery__
 *
 * To run a query within a React component, call `useGetUserGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserGroupsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserGroupsQuery(baseOptions?: Apollo.QueryHookOptions<GetUserGroupsQuery, GetUserGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserGroupsQuery, GetUserGroupsQueryVariables>(GetUserGroupsDocument, options);
      }
export function useGetUserGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserGroupsQuery, GetUserGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserGroupsQuery, GetUserGroupsQueryVariables>(GetUserGroupsDocument, options);
        }
// @ts-ignore
export function useGetUserGroupsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserGroupsQuery, GetUserGroupsQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserGroupsQuery, GetUserGroupsQueryVariables>;
export function useGetUserGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserGroupsQuery, GetUserGroupsQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserGroupsQuery | undefined, GetUserGroupsQueryVariables>;
export function useGetUserGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserGroupsQuery, GetUserGroupsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserGroupsQuery, GetUserGroupsQueryVariables>(GetUserGroupsDocument, options);
        }
export type GetUserGroupsQueryHookResult = ReturnType<typeof useGetUserGroupsQuery>;
export type GetUserGroupsLazyQueryHookResult = ReturnType<typeof useGetUserGroupsLazyQuery>;
export type GetUserGroupsSuspenseQueryHookResult = ReturnType<typeof useGetUserGroupsSuspenseQuery>;
export type GetUserGroupsQueryResult = Apollo.QueryResult<GetUserGroupsQuery, GetUserGroupsQueryVariables>;
export const GetCasesListDocument = gql`
    query GetCasesList($pageNumber: Int, $pageSize: Int, $types: [String], $status: [String], $priority: [String], $assignee: [String], $text: String, $fields: [String], $includeTaskEntityType: Boolean, $includeWorkflow: Boolean, $sortCol: String, $sortOrder: String, $domainIds: [String!]) @endpoint(name: asoc) {
  getCasesList(
    pageNumber: $pageNumber
    pageSize: $pageSize
    types: $types
    status: $status
    priority: $priority
    assignee: $assignee
    text: $text
    fields: $fields
    includeTaskEntityType: $includeTaskEntityType
    includeWorkflow: $includeWorkflow
    sortCol: $sortCol
    sortOrder: $sortOrder
    domainIds: $domainIds
  ) {
    data
  }
}
    `;

/**
 * __useGetCasesListQuery__
 *
 * To run a query within a React component, call `useGetCasesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCasesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCasesListQuery({
 *   variables: {
 *      pageNumber: // value for 'pageNumber'
 *      pageSize: // value for 'pageSize'
 *      types: // value for 'types'
 *      status: // value for 'status'
 *      priority: // value for 'priority'
 *      assignee: // value for 'assignee'
 *      text: // value for 'text'
 *      fields: // value for 'fields'
 *      includeTaskEntityType: // value for 'includeTaskEntityType'
 *      includeWorkflow: // value for 'includeWorkflow'
 *      sortCol: // value for 'sortCol'
 *      sortOrder: // value for 'sortOrder'
 *      domainIds: // value for 'domainIds'
 *   },
 * });
 */
export function useGetCasesListQuery(baseOptions?: Apollo.QueryHookOptions<GetCasesListQuery, GetCasesListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCasesListQuery, GetCasesListQueryVariables>(GetCasesListDocument, options);
      }
export function useGetCasesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCasesListQuery, GetCasesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCasesListQuery, GetCasesListQueryVariables>(GetCasesListDocument, options);
        }
// @ts-ignore
export function useGetCasesListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCasesListQuery, GetCasesListQueryVariables>): Apollo.UseSuspenseQueryResult<GetCasesListQuery, GetCasesListQueryVariables>;
export function useGetCasesListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCasesListQuery, GetCasesListQueryVariables>): Apollo.UseSuspenseQueryResult<GetCasesListQuery | undefined, GetCasesListQueryVariables>;
export function useGetCasesListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCasesListQuery, GetCasesListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCasesListQuery, GetCasesListQueryVariables>(GetCasesListDocument, options);
        }
export type GetCasesListQueryHookResult = ReturnType<typeof useGetCasesListQuery>;
export type GetCasesListLazyQueryHookResult = ReturnType<typeof useGetCasesListLazyQuery>;
export type GetCasesListSuspenseQueryHookResult = ReturnType<typeof useGetCasesListSuspenseQuery>;
export type GetCasesListQueryResult = Apollo.QueryResult<GetCasesListQuery, GetCasesListQueryVariables>;
export const GetCaseDetailsDocument = gql`
    query GetCaseDetails($caseId: String!, $xDevoDomain: String) @endpoint(name: asoc) {
  getCaseDetailsBasic(caseId: $caseId, xDevoDomain: $xDevoDomain) {
    data
  }
}
    `;

/**
 * __useGetCaseDetailsQuery__
 *
 * To run a query within a React component, call `useGetCaseDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCaseDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCaseDetailsQuery({
 *   variables: {
 *      caseId: // value for 'caseId'
 *      xDevoDomain: // value for 'xDevoDomain'
 *   },
 * });
 */
export function useGetCaseDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetCaseDetailsQuery, GetCaseDetailsQueryVariables> & ({ variables: GetCaseDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCaseDetailsQuery, GetCaseDetailsQueryVariables>(GetCaseDetailsDocument, options);
      }
export function useGetCaseDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCaseDetailsQuery, GetCaseDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCaseDetailsQuery, GetCaseDetailsQueryVariables>(GetCaseDetailsDocument, options);
        }
// @ts-ignore
export function useGetCaseDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCaseDetailsQuery, GetCaseDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCaseDetailsQuery, GetCaseDetailsQueryVariables>;
export function useGetCaseDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCaseDetailsQuery, GetCaseDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCaseDetailsQuery | undefined, GetCaseDetailsQueryVariables>;
export function useGetCaseDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCaseDetailsQuery, GetCaseDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCaseDetailsQuery, GetCaseDetailsQueryVariables>(GetCaseDetailsDocument, options);
        }
export type GetCaseDetailsQueryHookResult = ReturnType<typeof useGetCaseDetailsQuery>;
export type GetCaseDetailsLazyQueryHookResult = ReturnType<typeof useGetCaseDetailsLazyQuery>;
export type GetCaseDetailsSuspenseQueryHookResult = ReturnType<typeof useGetCaseDetailsSuspenseQuery>;
export type GetCaseDetailsQueryResult = Apollo.QueryResult<GetCaseDetailsQuery, GetCaseDetailsQueryVariables>;
export const GetCaseDocument = gql`
    query GetCase($id: String!) @endpoint(name: asoc) {
  getCaseFull(id: $id) {
    data
  }
}
    `;

/**
 * __useGetCaseQuery__
 *
 * To run a query within a React component, call `useGetCaseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCaseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCaseQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCaseQuery(baseOptions: Apollo.QueryHookOptions<GetCaseQuery, GetCaseQueryVariables> & ({ variables: GetCaseQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCaseQuery, GetCaseQueryVariables>(GetCaseDocument, options);
      }
export function useGetCaseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCaseQuery, GetCaseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCaseQuery, GetCaseQueryVariables>(GetCaseDocument, options);
        }
// @ts-ignore
export function useGetCaseSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCaseQuery, GetCaseQueryVariables>): Apollo.UseSuspenseQueryResult<GetCaseQuery, GetCaseQueryVariables>;
export function useGetCaseSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCaseQuery, GetCaseQueryVariables>): Apollo.UseSuspenseQueryResult<GetCaseQuery | undefined, GetCaseQueryVariables>;
export function useGetCaseSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCaseQuery, GetCaseQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCaseQuery, GetCaseQueryVariables>(GetCaseDocument, options);
        }
export type GetCaseQueryHookResult = ReturnType<typeof useGetCaseQuery>;
export type GetCaseLazyQueryHookResult = ReturnType<typeof useGetCaseLazyQuery>;
export type GetCaseSuspenseQueryHookResult = ReturnType<typeof useGetCaseSuspenseQuery>;
export type GetCaseQueryResult = Apollo.QueryResult<GetCaseQuery, GetCaseQueryVariables>;
export const GetCaseBasicDocument = gql`
    query GetCaseBasic($caseId: String!) @endpoint(name: asoc) {
  getCase(caseId: $caseId) {
    data
  }
}
    `;

/**
 * __useGetCaseBasicQuery__
 *
 * To run a query within a React component, call `useGetCaseBasicQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCaseBasicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCaseBasicQuery({
 *   variables: {
 *      caseId: // value for 'caseId'
 *   },
 * });
 */
export function useGetCaseBasicQuery(baseOptions: Apollo.QueryHookOptions<GetCaseBasicQuery, GetCaseBasicQueryVariables> & ({ variables: GetCaseBasicQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCaseBasicQuery, GetCaseBasicQueryVariables>(GetCaseBasicDocument, options);
      }
export function useGetCaseBasicLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCaseBasicQuery, GetCaseBasicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCaseBasicQuery, GetCaseBasicQueryVariables>(GetCaseBasicDocument, options);
        }
// @ts-ignore
export function useGetCaseBasicSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCaseBasicQuery, GetCaseBasicQueryVariables>): Apollo.UseSuspenseQueryResult<GetCaseBasicQuery, GetCaseBasicQueryVariables>;
export function useGetCaseBasicSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCaseBasicQuery, GetCaseBasicQueryVariables>): Apollo.UseSuspenseQueryResult<GetCaseBasicQuery | undefined, GetCaseBasicQueryVariables>;
export function useGetCaseBasicSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCaseBasicQuery, GetCaseBasicQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCaseBasicQuery, GetCaseBasicQueryVariables>(GetCaseBasicDocument, options);
        }
export type GetCaseBasicQueryHookResult = ReturnType<typeof useGetCaseBasicQuery>;
export type GetCaseBasicLazyQueryHookResult = ReturnType<typeof useGetCaseBasicLazyQuery>;
export type GetCaseBasicSuspenseQueryHookResult = ReturnType<typeof useGetCaseBasicSuspenseQuery>;
export type GetCaseBasicQueryResult = Apollo.QueryResult<GetCaseBasicQuery, GetCaseBasicQueryVariables>;
export const CheckCaseDeletePermissionsDocument = gql`
    query CheckCaseDeletePermissions($caseIds: [String]) @endpoint(name: asoc) {
  checkCaseDeletePermissions(caseIds: $caseIds) {
    data
  }
}
    `;

/**
 * __useCheckCaseDeletePermissionsQuery__
 *
 * To run a query within a React component, call `useCheckCaseDeletePermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckCaseDeletePermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckCaseDeletePermissionsQuery({
 *   variables: {
 *      caseIds: // value for 'caseIds'
 *   },
 * });
 */
export function useCheckCaseDeletePermissionsQuery(baseOptions?: Apollo.QueryHookOptions<CheckCaseDeletePermissionsQuery, CheckCaseDeletePermissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckCaseDeletePermissionsQuery, CheckCaseDeletePermissionsQueryVariables>(CheckCaseDeletePermissionsDocument, options);
      }
export function useCheckCaseDeletePermissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckCaseDeletePermissionsQuery, CheckCaseDeletePermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckCaseDeletePermissionsQuery, CheckCaseDeletePermissionsQueryVariables>(CheckCaseDeletePermissionsDocument, options);
        }
// @ts-ignore
export function useCheckCaseDeletePermissionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CheckCaseDeletePermissionsQuery, CheckCaseDeletePermissionsQueryVariables>): Apollo.UseSuspenseQueryResult<CheckCaseDeletePermissionsQuery, CheckCaseDeletePermissionsQueryVariables>;
export function useCheckCaseDeletePermissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CheckCaseDeletePermissionsQuery, CheckCaseDeletePermissionsQueryVariables>): Apollo.UseSuspenseQueryResult<CheckCaseDeletePermissionsQuery | undefined, CheckCaseDeletePermissionsQueryVariables>;
export function useCheckCaseDeletePermissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CheckCaseDeletePermissionsQuery, CheckCaseDeletePermissionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CheckCaseDeletePermissionsQuery, CheckCaseDeletePermissionsQueryVariables>(CheckCaseDeletePermissionsDocument, options);
        }
export type CheckCaseDeletePermissionsQueryHookResult = ReturnType<typeof useCheckCaseDeletePermissionsQuery>;
export type CheckCaseDeletePermissionsLazyQueryHookResult = ReturnType<typeof useCheckCaseDeletePermissionsLazyQuery>;
export type CheckCaseDeletePermissionsSuspenseQueryHookResult = ReturnType<typeof useCheckCaseDeletePermissionsSuspenseQuery>;
export type CheckCaseDeletePermissionsQueryResult = Apollo.QueryResult<CheckCaseDeletePermissionsQuery, CheckCaseDeletePermissionsQueryVariables>;
export const DownloadCasesCsvDocument = gql`
    query DownloadCasesCSV($input: DownloadCasesCsvInput!) @endpoint(name: asoc) {
  downloadCasesCsv(input: $input) {
    data
  }
}
    `;

/**
 * __useDownloadCasesCsvQuery__
 *
 * To run a query within a React component, call `useDownloadCasesCsvQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadCasesCsvQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadCasesCsvQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDownloadCasesCsvQuery(baseOptions: Apollo.QueryHookOptions<DownloadCasesCsvQuery, DownloadCasesCsvQueryVariables> & ({ variables: DownloadCasesCsvQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DownloadCasesCsvQuery, DownloadCasesCsvQueryVariables>(DownloadCasesCsvDocument, options);
      }
export function useDownloadCasesCsvLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadCasesCsvQuery, DownloadCasesCsvQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DownloadCasesCsvQuery, DownloadCasesCsvQueryVariables>(DownloadCasesCsvDocument, options);
        }
// @ts-ignore
export function useDownloadCasesCsvSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DownloadCasesCsvQuery, DownloadCasesCsvQueryVariables>): Apollo.UseSuspenseQueryResult<DownloadCasesCsvQuery, DownloadCasesCsvQueryVariables>;
export function useDownloadCasesCsvSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DownloadCasesCsvQuery, DownloadCasesCsvQueryVariables>): Apollo.UseSuspenseQueryResult<DownloadCasesCsvQuery | undefined, DownloadCasesCsvQueryVariables>;
export function useDownloadCasesCsvSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DownloadCasesCsvQuery, DownloadCasesCsvQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DownloadCasesCsvQuery, DownloadCasesCsvQueryVariables>(DownloadCasesCsvDocument, options);
        }
export type DownloadCasesCsvQueryHookResult = ReturnType<typeof useDownloadCasesCsvQuery>;
export type DownloadCasesCsvLazyQueryHookResult = ReturnType<typeof useDownloadCasesCsvLazyQuery>;
export type DownloadCasesCsvSuspenseQueryHookResult = ReturnType<typeof useDownloadCasesCsvSuspenseQuery>;
export type DownloadCasesCsvQueryResult = Apollo.QueryResult<DownloadCasesCsvQuery, DownloadCasesCsvQueryVariables>;
export const GetCaseHistoryDocument = gql`
    query GetCaseHistory($caseId: String!, $xDevoDomain: String) @endpoint(name: asoc) {
  getCaseHistory(caseId: $caseId, xDevoDomain: $xDevoDomain) {
    data
  }
}
    `;

/**
 * __useGetCaseHistoryQuery__
 *
 * To run a query within a React component, call `useGetCaseHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCaseHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCaseHistoryQuery({
 *   variables: {
 *      caseId: // value for 'caseId'
 *      xDevoDomain: // value for 'xDevoDomain'
 *   },
 * });
 */
export function useGetCaseHistoryQuery(baseOptions: Apollo.QueryHookOptions<GetCaseHistoryQuery, GetCaseHistoryQueryVariables> & ({ variables: GetCaseHistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCaseHistoryQuery, GetCaseHistoryQueryVariables>(GetCaseHistoryDocument, options);
      }
export function useGetCaseHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCaseHistoryQuery, GetCaseHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCaseHistoryQuery, GetCaseHistoryQueryVariables>(GetCaseHistoryDocument, options);
        }
// @ts-ignore
export function useGetCaseHistorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCaseHistoryQuery, GetCaseHistoryQueryVariables>): Apollo.UseSuspenseQueryResult<GetCaseHistoryQuery, GetCaseHistoryQueryVariables>;
export function useGetCaseHistorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCaseHistoryQuery, GetCaseHistoryQueryVariables>): Apollo.UseSuspenseQueryResult<GetCaseHistoryQuery | undefined, GetCaseHistoryQueryVariables>;
export function useGetCaseHistorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCaseHistoryQuery, GetCaseHistoryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCaseHistoryQuery, GetCaseHistoryQueryVariables>(GetCaseHistoryDocument, options);
        }
export type GetCaseHistoryQueryHookResult = ReturnType<typeof useGetCaseHistoryQuery>;
export type GetCaseHistoryLazyQueryHookResult = ReturnType<typeof useGetCaseHistoryLazyQuery>;
export type GetCaseHistorySuspenseQueryHookResult = ReturnType<typeof useGetCaseHistorySuspenseQuery>;
export type GetCaseHistoryQueryResult = Apollo.QueryResult<GetCaseHistoryQuery, GetCaseHistoryQueryVariables>;
export const GetDevoCaseAlertsDocument = gql`
    query GetDevoCaseAlerts($caseId: String!, $pageNumber: Int, $pageSize: Int, $groupName: String, $xDevoDomain: String) @endpoint(name: asoc) {
  getDevoCaseAlerts(
    caseId: $caseId
    pageNumber: $pageNumber
    pageSize: $pageSize
    groupName: $groupName
    xDevoDomain: $xDevoDomain
  ) {
    data
  }
}
    `;

/**
 * __useGetDevoCaseAlertsQuery__
 *
 * To run a query within a React component, call `useGetDevoCaseAlertsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDevoCaseAlertsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDevoCaseAlertsQuery({
 *   variables: {
 *      caseId: // value for 'caseId'
 *      pageNumber: // value for 'pageNumber'
 *      pageSize: // value for 'pageSize'
 *      groupName: // value for 'groupName'
 *      xDevoDomain: // value for 'xDevoDomain'
 *   },
 * });
 */
export function useGetDevoCaseAlertsQuery(baseOptions: Apollo.QueryHookOptions<GetDevoCaseAlertsQuery, GetDevoCaseAlertsQueryVariables> & ({ variables: GetDevoCaseAlertsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDevoCaseAlertsQuery, GetDevoCaseAlertsQueryVariables>(GetDevoCaseAlertsDocument, options);
      }
export function useGetDevoCaseAlertsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDevoCaseAlertsQuery, GetDevoCaseAlertsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDevoCaseAlertsQuery, GetDevoCaseAlertsQueryVariables>(GetDevoCaseAlertsDocument, options);
        }
// @ts-ignore
export function useGetDevoCaseAlertsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDevoCaseAlertsQuery, GetDevoCaseAlertsQueryVariables>): Apollo.UseSuspenseQueryResult<GetDevoCaseAlertsQuery, GetDevoCaseAlertsQueryVariables>;
export function useGetDevoCaseAlertsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDevoCaseAlertsQuery, GetDevoCaseAlertsQueryVariables>): Apollo.UseSuspenseQueryResult<GetDevoCaseAlertsQuery | undefined, GetDevoCaseAlertsQueryVariables>;
export function useGetDevoCaseAlertsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDevoCaseAlertsQuery, GetDevoCaseAlertsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDevoCaseAlertsQuery, GetDevoCaseAlertsQueryVariables>(GetDevoCaseAlertsDocument, options);
        }
export type GetDevoCaseAlertsQueryHookResult = ReturnType<typeof useGetDevoCaseAlertsQuery>;
export type GetDevoCaseAlertsLazyQueryHookResult = ReturnType<typeof useGetDevoCaseAlertsLazyQuery>;
export type GetDevoCaseAlertsSuspenseQueryHookResult = ReturnType<typeof useGetDevoCaseAlertsSuspenseQuery>;
export type GetDevoCaseAlertsQueryResult = Apollo.QueryResult<GetDevoCaseAlertsQuery, GetDevoCaseAlertsQueryVariables>;
export const GetDevoCaseAlertsGroupedDocument = gql`
    query GetDevoCaseAlertsGrouped($caseId: String!, $pageNumber: Int, $pageSize: Int, $xDevoDomain: String) @endpoint(name: asoc) {
  getDevoCaseAlertsGrouped(
    caseId: $caseId
    pageNumber: $pageNumber
    pageSize: $pageSize
    xDevoDomain: $xDevoDomain
  ) {
    data
  }
}
    `;

/**
 * __useGetDevoCaseAlertsGroupedQuery__
 *
 * To run a query within a React component, call `useGetDevoCaseAlertsGroupedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDevoCaseAlertsGroupedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDevoCaseAlertsGroupedQuery({
 *   variables: {
 *      caseId: // value for 'caseId'
 *      pageNumber: // value for 'pageNumber'
 *      pageSize: // value for 'pageSize'
 *      xDevoDomain: // value for 'xDevoDomain'
 *   },
 * });
 */
export function useGetDevoCaseAlertsGroupedQuery(baseOptions: Apollo.QueryHookOptions<GetDevoCaseAlertsGroupedQuery, GetDevoCaseAlertsGroupedQueryVariables> & ({ variables: GetDevoCaseAlertsGroupedQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDevoCaseAlertsGroupedQuery, GetDevoCaseAlertsGroupedQueryVariables>(GetDevoCaseAlertsGroupedDocument, options);
      }
export function useGetDevoCaseAlertsGroupedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDevoCaseAlertsGroupedQuery, GetDevoCaseAlertsGroupedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDevoCaseAlertsGroupedQuery, GetDevoCaseAlertsGroupedQueryVariables>(GetDevoCaseAlertsGroupedDocument, options);
        }
// @ts-ignore
export function useGetDevoCaseAlertsGroupedSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDevoCaseAlertsGroupedQuery, GetDevoCaseAlertsGroupedQueryVariables>): Apollo.UseSuspenseQueryResult<GetDevoCaseAlertsGroupedQuery, GetDevoCaseAlertsGroupedQueryVariables>;
export function useGetDevoCaseAlertsGroupedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDevoCaseAlertsGroupedQuery, GetDevoCaseAlertsGroupedQueryVariables>): Apollo.UseSuspenseQueryResult<GetDevoCaseAlertsGroupedQuery | undefined, GetDevoCaseAlertsGroupedQueryVariables>;
export function useGetDevoCaseAlertsGroupedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDevoCaseAlertsGroupedQuery, GetDevoCaseAlertsGroupedQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDevoCaseAlertsGroupedQuery, GetDevoCaseAlertsGroupedQueryVariables>(GetDevoCaseAlertsGroupedDocument, options);
        }
export type GetDevoCaseAlertsGroupedQueryHookResult = ReturnType<typeof useGetDevoCaseAlertsGroupedQuery>;
export type GetDevoCaseAlertsGroupedLazyQueryHookResult = ReturnType<typeof useGetDevoCaseAlertsGroupedLazyQuery>;
export type GetDevoCaseAlertsGroupedSuspenseQueryHookResult = ReturnType<typeof useGetDevoCaseAlertsGroupedSuspenseQuery>;
export type GetDevoCaseAlertsGroupedQueryResult = Apollo.QueryResult<GetDevoCaseAlertsGroupedQuery, GetDevoCaseAlertsGroupedQueryVariables>;
export const GetDevoAlertDetailsDocument = gql`
    query GetDevoAlertDetails($alertId: String!, $timezone: String, $xDevoDomain: String) @endpoint(name: asoc) {
  getDevoAlertDetails(
    alertId: $alertId
    timezone: $timezone
    xDevoDomain: $xDevoDomain
  ) {
    data
  }
}
    `;

/**
 * __useGetDevoAlertDetailsQuery__
 *
 * To run a query within a React component, call `useGetDevoAlertDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDevoAlertDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDevoAlertDetailsQuery({
 *   variables: {
 *      alertId: // value for 'alertId'
 *      timezone: // value for 'timezone'
 *      xDevoDomain: // value for 'xDevoDomain'
 *   },
 * });
 */
export function useGetDevoAlertDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetDevoAlertDetailsQuery, GetDevoAlertDetailsQueryVariables> & ({ variables: GetDevoAlertDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDevoAlertDetailsQuery, GetDevoAlertDetailsQueryVariables>(GetDevoAlertDetailsDocument, options);
      }
export function useGetDevoAlertDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDevoAlertDetailsQuery, GetDevoAlertDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDevoAlertDetailsQuery, GetDevoAlertDetailsQueryVariables>(GetDevoAlertDetailsDocument, options);
        }
// @ts-ignore
export function useGetDevoAlertDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDevoAlertDetailsQuery, GetDevoAlertDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GetDevoAlertDetailsQuery, GetDevoAlertDetailsQueryVariables>;
export function useGetDevoAlertDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDevoAlertDetailsQuery, GetDevoAlertDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GetDevoAlertDetailsQuery | undefined, GetDevoAlertDetailsQueryVariables>;
export function useGetDevoAlertDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDevoAlertDetailsQuery, GetDevoAlertDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDevoAlertDetailsQuery, GetDevoAlertDetailsQueryVariables>(GetDevoAlertDetailsDocument, options);
        }
export type GetDevoAlertDetailsQueryHookResult = ReturnType<typeof useGetDevoAlertDetailsQuery>;
export type GetDevoAlertDetailsLazyQueryHookResult = ReturnType<typeof useGetDevoAlertDetailsLazyQuery>;
export type GetDevoAlertDetailsSuspenseQueryHookResult = ReturnType<typeof useGetDevoAlertDetailsSuspenseQuery>;
export type GetDevoAlertDetailsQueryResult = Apollo.QueryResult<GetDevoAlertDetailsQuery, GetDevoAlertDetailsQueryVariables>;
export const GetDevoAlertQueryIntervalDocument = gql`
    query GetDevoAlertQueryInterval($alertId: String!, $xDevoDomain: String) @endpoint(name: asoc) {
  getDevoAlertQueryInterval(alertId: $alertId, xDevoDomain: $xDevoDomain) {
    data
  }
}
    `;

/**
 * __useGetDevoAlertQueryIntervalQuery__
 *
 * To run a query within a React component, call `useGetDevoAlertQueryIntervalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDevoAlertQueryIntervalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDevoAlertQueryIntervalQuery({
 *   variables: {
 *      alertId: // value for 'alertId'
 *      xDevoDomain: // value for 'xDevoDomain'
 *   },
 * });
 */
export function useGetDevoAlertQueryIntervalQuery(baseOptions: Apollo.QueryHookOptions<GetDevoAlertQueryIntervalQuery, GetDevoAlertQueryIntervalQueryVariables> & ({ variables: GetDevoAlertQueryIntervalQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDevoAlertQueryIntervalQuery, GetDevoAlertQueryIntervalQueryVariables>(GetDevoAlertQueryIntervalDocument, options);
      }
export function useGetDevoAlertQueryIntervalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDevoAlertQueryIntervalQuery, GetDevoAlertQueryIntervalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDevoAlertQueryIntervalQuery, GetDevoAlertQueryIntervalQueryVariables>(GetDevoAlertQueryIntervalDocument, options);
        }
// @ts-ignore
export function useGetDevoAlertQueryIntervalSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDevoAlertQueryIntervalQuery, GetDevoAlertQueryIntervalQueryVariables>): Apollo.UseSuspenseQueryResult<GetDevoAlertQueryIntervalQuery, GetDevoAlertQueryIntervalQueryVariables>;
export function useGetDevoAlertQueryIntervalSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDevoAlertQueryIntervalQuery, GetDevoAlertQueryIntervalQueryVariables>): Apollo.UseSuspenseQueryResult<GetDevoAlertQueryIntervalQuery | undefined, GetDevoAlertQueryIntervalQueryVariables>;
export function useGetDevoAlertQueryIntervalSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDevoAlertQueryIntervalQuery, GetDevoAlertQueryIntervalQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDevoAlertQueryIntervalQuery, GetDevoAlertQueryIntervalQueryVariables>(GetDevoAlertQueryIntervalDocument, options);
        }
export type GetDevoAlertQueryIntervalQueryHookResult = ReturnType<typeof useGetDevoAlertQueryIntervalQuery>;
export type GetDevoAlertQueryIntervalLazyQueryHookResult = ReturnType<typeof useGetDevoAlertQueryIntervalLazyQuery>;
export type GetDevoAlertQueryIntervalSuspenseQueryHookResult = ReturnType<typeof useGetDevoAlertQueryIntervalSuspenseQuery>;
export type GetDevoAlertQueryIntervalQueryResult = Apollo.QueryResult<GetDevoAlertQueryIntervalQuery, GetDevoAlertQueryIntervalQueryVariables>;
export const GetSoarAlertsAdvancedDocument = gql`
    query GetSoarAlertsAdvanced($caseId: String, $pageNumber: Int, $pageSize: Int, $query: String, $sortCol: String, $sortOrder: String) @endpoint(name: asoc) {
  getSoarAlertsAdvanced(
    caseId: $caseId
    pageNumber: $pageNumber
    pageSize: $pageSize
    query: $query
    sortCol: $sortCol
    sortOrder: $sortOrder
  ) {
    alerts {
      id
      name
      alertType
      createdAt
      description
      alertSource {
        id
        alertSource {
          type
          obj
        }
      }
      mappedAlertFieldValues {
        caseFieldId
        displayName
        fieldName
        fieldType
        value
      }
    }
    totalSize
    query
  }
}
    `;

/**
 * __useGetSoarAlertsAdvancedQuery__
 *
 * To run a query within a React component, call `useGetSoarAlertsAdvancedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSoarAlertsAdvancedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSoarAlertsAdvancedQuery({
 *   variables: {
 *      caseId: // value for 'caseId'
 *      pageNumber: // value for 'pageNumber'
 *      pageSize: // value for 'pageSize'
 *      query: // value for 'query'
 *      sortCol: // value for 'sortCol'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useGetSoarAlertsAdvancedQuery(baseOptions?: Apollo.QueryHookOptions<GetSoarAlertsAdvancedQuery, GetSoarAlertsAdvancedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSoarAlertsAdvancedQuery, GetSoarAlertsAdvancedQueryVariables>(GetSoarAlertsAdvancedDocument, options);
      }
export function useGetSoarAlertsAdvancedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSoarAlertsAdvancedQuery, GetSoarAlertsAdvancedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSoarAlertsAdvancedQuery, GetSoarAlertsAdvancedQueryVariables>(GetSoarAlertsAdvancedDocument, options);
        }
// @ts-ignore
export function useGetSoarAlertsAdvancedSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSoarAlertsAdvancedQuery, GetSoarAlertsAdvancedQueryVariables>): Apollo.UseSuspenseQueryResult<GetSoarAlertsAdvancedQuery, GetSoarAlertsAdvancedQueryVariables>;
export function useGetSoarAlertsAdvancedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSoarAlertsAdvancedQuery, GetSoarAlertsAdvancedQueryVariables>): Apollo.UseSuspenseQueryResult<GetSoarAlertsAdvancedQuery | undefined, GetSoarAlertsAdvancedQueryVariables>;
export function useGetSoarAlertsAdvancedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSoarAlertsAdvancedQuery, GetSoarAlertsAdvancedQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSoarAlertsAdvancedQuery, GetSoarAlertsAdvancedQueryVariables>(GetSoarAlertsAdvancedDocument, options);
        }
export type GetSoarAlertsAdvancedQueryHookResult = ReturnType<typeof useGetSoarAlertsAdvancedQuery>;
export type GetSoarAlertsAdvancedLazyQueryHookResult = ReturnType<typeof useGetSoarAlertsAdvancedLazyQuery>;
export type GetSoarAlertsAdvancedSuspenseQueryHookResult = ReturnType<typeof useGetSoarAlertsAdvancedSuspenseQuery>;
export type GetSoarAlertsAdvancedQueryResult = Apollo.QueryResult<GetSoarAlertsAdvancedQuery, GetSoarAlertsAdvancedQueryVariables>;
export const GetSoarAlertDocument = gql`
    query GetSoarAlert($alertId: String!) @endpoint(name: asoc) {
  getSoarAlert(alertId: $alertId) {
    id
    name
    description
    alertType
    createdAt
    additionalFields
    alertSource {
      id
      alertSource {
        type
        obj
      }
    }
    mappedAlertFieldValues {
      caseFieldId
      displayName
      fieldName
      fieldType
      value
    }
    comments
    history
  }
}
    `;

/**
 * __useGetSoarAlertQuery__
 *
 * To run a query within a React component, call `useGetSoarAlertQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSoarAlertQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSoarAlertQuery({
 *   variables: {
 *      alertId: // value for 'alertId'
 *   },
 * });
 */
export function useGetSoarAlertQuery(baseOptions: Apollo.QueryHookOptions<GetSoarAlertQuery, GetSoarAlertQueryVariables> & ({ variables: GetSoarAlertQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSoarAlertQuery, GetSoarAlertQueryVariables>(GetSoarAlertDocument, options);
      }
export function useGetSoarAlertLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSoarAlertQuery, GetSoarAlertQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSoarAlertQuery, GetSoarAlertQueryVariables>(GetSoarAlertDocument, options);
        }
// @ts-ignore
export function useGetSoarAlertSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSoarAlertQuery, GetSoarAlertQueryVariables>): Apollo.UseSuspenseQueryResult<GetSoarAlertQuery, GetSoarAlertQueryVariables>;
export function useGetSoarAlertSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSoarAlertQuery, GetSoarAlertQueryVariables>): Apollo.UseSuspenseQueryResult<GetSoarAlertQuery | undefined, GetSoarAlertQueryVariables>;
export function useGetSoarAlertSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSoarAlertQuery, GetSoarAlertQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSoarAlertQuery, GetSoarAlertQueryVariables>(GetSoarAlertDocument, options);
        }
export type GetSoarAlertQueryHookResult = ReturnType<typeof useGetSoarAlertQuery>;
export type GetSoarAlertLazyQueryHookResult = ReturnType<typeof useGetSoarAlertLazyQuery>;
export type GetSoarAlertSuspenseQueryHookResult = ReturnType<typeof useGetSoarAlertSuspenseQuery>;
export type GetSoarAlertQueryResult = Apollo.QueryResult<GetSoarAlertQuery, GetSoarAlertQueryVariables>;
export const GetCaseTypeFieldsDocument = gql`
    query GetCaseTypeFields($caseType: String!) @endpoint(name: asoc) {
  getCaseTypeFields(caseType: $caseType) {
    data
  }
}
    `;

/**
 * __useGetCaseTypeFieldsQuery__
 *
 * To run a query within a React component, call `useGetCaseTypeFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCaseTypeFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCaseTypeFieldsQuery({
 *   variables: {
 *      caseType: // value for 'caseType'
 *   },
 * });
 */
export function useGetCaseTypeFieldsQuery(baseOptions: Apollo.QueryHookOptions<GetCaseTypeFieldsQuery, GetCaseTypeFieldsQueryVariables> & ({ variables: GetCaseTypeFieldsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCaseTypeFieldsQuery, GetCaseTypeFieldsQueryVariables>(GetCaseTypeFieldsDocument, options);
      }
export function useGetCaseTypeFieldsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCaseTypeFieldsQuery, GetCaseTypeFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCaseTypeFieldsQuery, GetCaseTypeFieldsQueryVariables>(GetCaseTypeFieldsDocument, options);
        }
// @ts-ignore
export function useGetCaseTypeFieldsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCaseTypeFieldsQuery, GetCaseTypeFieldsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCaseTypeFieldsQuery, GetCaseTypeFieldsQueryVariables>;
export function useGetCaseTypeFieldsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCaseTypeFieldsQuery, GetCaseTypeFieldsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCaseTypeFieldsQuery | undefined, GetCaseTypeFieldsQueryVariables>;
export function useGetCaseTypeFieldsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCaseTypeFieldsQuery, GetCaseTypeFieldsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCaseTypeFieldsQuery, GetCaseTypeFieldsQueryVariables>(GetCaseTypeFieldsDocument, options);
        }
export type GetCaseTypeFieldsQueryHookResult = ReturnType<typeof useGetCaseTypeFieldsQuery>;
export type GetCaseTypeFieldsLazyQueryHookResult = ReturnType<typeof useGetCaseTypeFieldsLazyQuery>;
export type GetCaseTypeFieldsSuspenseQueryHookResult = ReturnType<typeof useGetCaseTypeFieldsSuspenseQuery>;
export type GetCaseTypeFieldsQueryResult = Apollo.QueryResult<GetCaseTypeFieldsQuery, GetCaseTypeFieldsQueryVariables>;
export const GetFieldDefinitionsDocument = gql`
    query GetFieldDefinitions($systemFields: Boolean = true, $pageSize: Int = 500, $after: Int = 0, $domainIds: [String!]) @endpoint(name: asoc) {
  getFieldDefinitions(
    systemFields: $systemFields
    pageSize: $pageSize
    after: $after
    domainIds: $domainIds
  ) {
    data
  }
}
    `;

/**
 * __useGetFieldDefinitionsQuery__
 *
 * To run a query within a React component, call `useGetFieldDefinitionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFieldDefinitionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFieldDefinitionsQuery({
 *   variables: {
 *      systemFields: // value for 'systemFields'
 *      pageSize: // value for 'pageSize'
 *      after: // value for 'after'
 *      domainIds: // value for 'domainIds'
 *   },
 * });
 */
export function useGetFieldDefinitionsQuery(baseOptions?: Apollo.QueryHookOptions<GetFieldDefinitionsQuery, GetFieldDefinitionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFieldDefinitionsQuery, GetFieldDefinitionsQueryVariables>(GetFieldDefinitionsDocument, options);
      }
export function useGetFieldDefinitionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFieldDefinitionsQuery, GetFieldDefinitionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFieldDefinitionsQuery, GetFieldDefinitionsQueryVariables>(GetFieldDefinitionsDocument, options);
        }
// @ts-ignore
export function useGetFieldDefinitionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetFieldDefinitionsQuery, GetFieldDefinitionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetFieldDefinitionsQuery, GetFieldDefinitionsQueryVariables>;
export function useGetFieldDefinitionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFieldDefinitionsQuery, GetFieldDefinitionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetFieldDefinitionsQuery | undefined, GetFieldDefinitionsQueryVariables>;
export function useGetFieldDefinitionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFieldDefinitionsQuery, GetFieldDefinitionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFieldDefinitionsQuery, GetFieldDefinitionsQueryVariables>(GetFieldDefinitionsDocument, options);
        }
export type GetFieldDefinitionsQueryHookResult = ReturnType<typeof useGetFieldDefinitionsQuery>;
export type GetFieldDefinitionsLazyQueryHookResult = ReturnType<typeof useGetFieldDefinitionsLazyQuery>;
export type GetFieldDefinitionsSuspenseQueryHookResult = ReturnType<typeof useGetFieldDefinitionsSuspenseQuery>;
export type GetFieldDefinitionsQueryResult = Apollo.QueryResult<GetFieldDefinitionsQuery, GetFieldDefinitionsQueryVariables>;
export const GetCaseFieldsDocument = gql`
    query GetCaseFields($caseId: String!, $xDevoDomain: String) @endpoint(name: asoc) {
  getCaseFields(caseId: $caseId, xDevoDomain: $xDevoDomain) {
    data
  }
}
    `;

/**
 * __useGetCaseFieldsQuery__
 *
 * To run a query within a React component, call `useGetCaseFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCaseFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCaseFieldsQuery({
 *   variables: {
 *      caseId: // value for 'caseId'
 *      xDevoDomain: // value for 'xDevoDomain'
 *   },
 * });
 */
export function useGetCaseFieldsQuery(baseOptions: Apollo.QueryHookOptions<GetCaseFieldsQuery, GetCaseFieldsQueryVariables> & ({ variables: GetCaseFieldsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCaseFieldsQuery, GetCaseFieldsQueryVariables>(GetCaseFieldsDocument, options);
      }
export function useGetCaseFieldsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCaseFieldsQuery, GetCaseFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCaseFieldsQuery, GetCaseFieldsQueryVariables>(GetCaseFieldsDocument, options);
        }
// @ts-ignore
export function useGetCaseFieldsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCaseFieldsQuery, GetCaseFieldsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCaseFieldsQuery, GetCaseFieldsQueryVariables>;
export function useGetCaseFieldsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCaseFieldsQuery, GetCaseFieldsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCaseFieldsQuery | undefined, GetCaseFieldsQueryVariables>;
export function useGetCaseFieldsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCaseFieldsQuery, GetCaseFieldsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCaseFieldsQuery, GetCaseFieldsQueryVariables>(GetCaseFieldsDocument, options);
        }
export type GetCaseFieldsQueryHookResult = ReturnType<typeof useGetCaseFieldsQuery>;
export type GetCaseFieldsLazyQueryHookResult = ReturnType<typeof useGetCaseFieldsLazyQuery>;
export type GetCaseFieldsSuspenseQueryHookResult = ReturnType<typeof useGetCaseFieldsSuspenseQuery>;
export type GetCaseFieldsQueryResult = Apollo.QueryResult<GetCaseFieldsQuery, GetCaseFieldsQueryVariables>;
export const GetTaskFormDocument = gql`
    query GetTaskForm($taskId: String!, $xDevoDomain: String) @endpoint(name: asoc) {
  getTaskForm(taskId: $taskId, xDevoDomain: $xDevoDomain) {
    data
  }
}
    `;

/**
 * __useGetTaskFormQuery__
 *
 * To run a query within a React component, call `useGetTaskFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaskFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaskFormQuery({
 *   variables: {
 *      taskId: // value for 'taskId'
 *      xDevoDomain: // value for 'xDevoDomain'
 *   },
 * });
 */
export function useGetTaskFormQuery(baseOptions: Apollo.QueryHookOptions<GetTaskFormQuery, GetTaskFormQueryVariables> & ({ variables: GetTaskFormQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTaskFormQuery, GetTaskFormQueryVariables>(GetTaskFormDocument, options);
      }
export function useGetTaskFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTaskFormQuery, GetTaskFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTaskFormQuery, GetTaskFormQueryVariables>(GetTaskFormDocument, options);
        }
// @ts-ignore
export function useGetTaskFormSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTaskFormQuery, GetTaskFormQueryVariables>): Apollo.UseSuspenseQueryResult<GetTaskFormQuery, GetTaskFormQueryVariables>;
export function useGetTaskFormSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTaskFormQuery, GetTaskFormQueryVariables>): Apollo.UseSuspenseQueryResult<GetTaskFormQuery | undefined, GetTaskFormQueryVariables>;
export function useGetTaskFormSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTaskFormQuery, GetTaskFormQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTaskFormQuery, GetTaskFormQueryVariables>(GetTaskFormDocument, options);
        }
export type GetTaskFormQueryHookResult = ReturnType<typeof useGetTaskFormQuery>;
export type GetTaskFormLazyQueryHookResult = ReturnType<typeof useGetTaskFormLazyQuery>;
export type GetTaskFormSuspenseQueryHookResult = ReturnType<typeof useGetTaskFormSuspenseQuery>;
export type GetTaskFormQueryResult = Apollo.QueryResult<GetTaskFormQuery, GetTaskFormQueryVariables>;
export const DownloadAttachmentDocument = gql`
    query DownloadAttachment($attachmentUrl: String!, $xDevoDomain: String) @endpoint(name: asoc) {
  downloadAttachment(attachmentUrl: $attachmentUrl, xDevoDomain: $xDevoDomain) {
    data
  }
}
    `;

/**
 * __useDownloadAttachmentQuery__
 *
 * To run a query within a React component, call `useDownloadAttachmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadAttachmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadAttachmentQuery({
 *   variables: {
 *      attachmentUrl: // value for 'attachmentUrl'
 *      xDevoDomain: // value for 'xDevoDomain'
 *   },
 * });
 */
export function useDownloadAttachmentQuery(baseOptions: Apollo.QueryHookOptions<DownloadAttachmentQuery, DownloadAttachmentQueryVariables> & ({ variables: DownloadAttachmentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DownloadAttachmentQuery, DownloadAttachmentQueryVariables>(DownloadAttachmentDocument, options);
      }
export function useDownloadAttachmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadAttachmentQuery, DownloadAttachmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DownloadAttachmentQuery, DownloadAttachmentQueryVariables>(DownloadAttachmentDocument, options);
        }
// @ts-ignore
export function useDownloadAttachmentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DownloadAttachmentQuery, DownloadAttachmentQueryVariables>): Apollo.UseSuspenseQueryResult<DownloadAttachmentQuery, DownloadAttachmentQueryVariables>;
export function useDownloadAttachmentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DownloadAttachmentQuery, DownloadAttachmentQueryVariables>): Apollo.UseSuspenseQueryResult<DownloadAttachmentQuery | undefined, DownloadAttachmentQueryVariables>;
export function useDownloadAttachmentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DownloadAttachmentQuery, DownloadAttachmentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DownloadAttachmentQuery, DownloadAttachmentQueryVariables>(DownloadAttachmentDocument, options);
        }
export type DownloadAttachmentQueryHookResult = ReturnType<typeof useDownloadAttachmentQuery>;
export type DownloadAttachmentLazyQueryHookResult = ReturnType<typeof useDownloadAttachmentLazyQuery>;
export type DownloadAttachmentSuspenseQueryHookResult = ReturnType<typeof useDownloadAttachmentSuspenseQuery>;
export type DownloadAttachmentQueryResult = Apollo.QueryResult<DownloadAttachmentQuery, DownloadAttachmentQueryVariables>;
export const GetSavedSearchesDocument = gql`
    query GetSavedSearches @endpoint(name: asoc) {
  getSavedSearches {
    data
  }
}
    `;

/**
 * __useGetSavedSearchesQuery__
 *
 * To run a query within a React component, call `useGetSavedSearchesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSavedSearchesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSavedSearchesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSavedSearchesQuery(baseOptions?: Apollo.QueryHookOptions<GetSavedSearchesQuery, GetSavedSearchesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSavedSearchesQuery, GetSavedSearchesQueryVariables>(GetSavedSearchesDocument, options);
      }
export function useGetSavedSearchesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSavedSearchesQuery, GetSavedSearchesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSavedSearchesQuery, GetSavedSearchesQueryVariables>(GetSavedSearchesDocument, options);
        }
// @ts-ignore
export function useGetSavedSearchesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSavedSearchesQuery, GetSavedSearchesQueryVariables>): Apollo.UseSuspenseQueryResult<GetSavedSearchesQuery, GetSavedSearchesQueryVariables>;
export function useGetSavedSearchesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSavedSearchesQuery, GetSavedSearchesQueryVariables>): Apollo.UseSuspenseQueryResult<GetSavedSearchesQuery | undefined, GetSavedSearchesQueryVariables>;
export function useGetSavedSearchesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSavedSearchesQuery, GetSavedSearchesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSavedSearchesQuery, GetSavedSearchesQueryVariables>(GetSavedSearchesDocument, options);
        }
export type GetSavedSearchesQueryHookResult = ReturnType<typeof useGetSavedSearchesQuery>;
export type GetSavedSearchesLazyQueryHookResult = ReturnType<typeof useGetSavedSearchesLazyQuery>;
export type GetSavedSearchesSuspenseQueryHookResult = ReturnType<typeof useGetSavedSearchesSuspenseQuery>;
export type GetSavedSearchesQueryResult = Apollo.QueryResult<GetSavedSearchesQuery, GetSavedSearchesQueryVariables>;
export const ConvertToAdvancedQueryDocument = gql`
    query ConvertToAdvancedQuery($text: String, $types: [String], $priority: [String], $status: [String], $assignee: [String], $fields: [String], $xDevoDomain: String) @endpoint(name: asoc) {
  convertToAdvancedQuery(
    text: $text
    types: $types
    priority: $priority
    status: $status
    assignee: $assignee
    fields: $fields
    xDevoDomain: $xDevoDomain
  ) {
    data
  }
}
    `;

/**
 * __useConvertToAdvancedQueryQuery__
 *
 * To run a query within a React component, call `useConvertToAdvancedQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useConvertToAdvancedQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConvertToAdvancedQueryQuery({
 *   variables: {
 *      text: // value for 'text'
 *      types: // value for 'types'
 *      priority: // value for 'priority'
 *      status: // value for 'status'
 *      assignee: // value for 'assignee'
 *      fields: // value for 'fields'
 *      xDevoDomain: // value for 'xDevoDomain'
 *   },
 * });
 */
export function useConvertToAdvancedQueryQuery(baseOptions?: Apollo.QueryHookOptions<ConvertToAdvancedQueryQuery, ConvertToAdvancedQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConvertToAdvancedQueryQuery, ConvertToAdvancedQueryQueryVariables>(ConvertToAdvancedQueryDocument, options);
      }
export function useConvertToAdvancedQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConvertToAdvancedQueryQuery, ConvertToAdvancedQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConvertToAdvancedQueryQuery, ConvertToAdvancedQueryQueryVariables>(ConvertToAdvancedQueryDocument, options);
        }
// @ts-ignore
export function useConvertToAdvancedQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ConvertToAdvancedQueryQuery, ConvertToAdvancedQueryQueryVariables>): Apollo.UseSuspenseQueryResult<ConvertToAdvancedQueryQuery, ConvertToAdvancedQueryQueryVariables>;
export function useConvertToAdvancedQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ConvertToAdvancedQueryQuery, ConvertToAdvancedQueryQueryVariables>): Apollo.UseSuspenseQueryResult<ConvertToAdvancedQueryQuery | undefined, ConvertToAdvancedQueryQueryVariables>;
export function useConvertToAdvancedQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ConvertToAdvancedQueryQuery, ConvertToAdvancedQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ConvertToAdvancedQueryQuery, ConvertToAdvancedQueryQueryVariables>(ConvertToAdvancedQueryDocument, options);
        }
export type ConvertToAdvancedQueryQueryHookResult = ReturnType<typeof useConvertToAdvancedQueryQuery>;
export type ConvertToAdvancedQueryLazyQueryHookResult = ReturnType<typeof useConvertToAdvancedQueryLazyQuery>;
export type ConvertToAdvancedQuerySuspenseQueryHookResult = ReturnType<typeof useConvertToAdvancedQuerySuspenseQuery>;
export type ConvertToAdvancedQueryQueryResult = Apollo.QueryResult<ConvertToAdvancedQueryQuery, ConvertToAdvancedQueryQueryVariables>;
export const GetCasesAdvancedSearchDocument = gql`
    query GetCasesAdvancedSearch($pageNumber: Int, $pageSize: Int, $query: String!, $includeTaskEntityType: Boolean, $includeWorkflow: Boolean, $sortCol: String, $sortOrder: String, $domainIds: [String!], $xDevoDomain: String) @endpoint(name: asoc) {
  getCasesAdvancedSearch(
    pageNumber: $pageNumber
    pageSize: $pageSize
    query: $query
    includeTaskEntityType: $includeTaskEntityType
    includeWorkflow: $includeWorkflow
    sortCol: $sortCol
    sortOrder: $sortOrder
    domainIds: $domainIds
    xDevoDomain: $xDevoDomain
  ) {
    data
  }
}
    `;

/**
 * __useGetCasesAdvancedSearchQuery__
 *
 * To run a query within a React component, call `useGetCasesAdvancedSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCasesAdvancedSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCasesAdvancedSearchQuery({
 *   variables: {
 *      pageNumber: // value for 'pageNumber'
 *      pageSize: // value for 'pageSize'
 *      query: // value for 'query'
 *      includeTaskEntityType: // value for 'includeTaskEntityType'
 *      includeWorkflow: // value for 'includeWorkflow'
 *      sortCol: // value for 'sortCol'
 *      sortOrder: // value for 'sortOrder'
 *      domainIds: // value for 'domainIds'
 *      xDevoDomain: // value for 'xDevoDomain'
 *   },
 * });
 */
export function useGetCasesAdvancedSearchQuery(baseOptions: Apollo.QueryHookOptions<GetCasesAdvancedSearchQuery, GetCasesAdvancedSearchQueryVariables> & ({ variables: GetCasesAdvancedSearchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCasesAdvancedSearchQuery, GetCasesAdvancedSearchQueryVariables>(GetCasesAdvancedSearchDocument, options);
      }
export function useGetCasesAdvancedSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCasesAdvancedSearchQuery, GetCasesAdvancedSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCasesAdvancedSearchQuery, GetCasesAdvancedSearchQueryVariables>(GetCasesAdvancedSearchDocument, options);
        }
// @ts-ignore
export function useGetCasesAdvancedSearchSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCasesAdvancedSearchQuery, GetCasesAdvancedSearchQueryVariables>): Apollo.UseSuspenseQueryResult<GetCasesAdvancedSearchQuery, GetCasesAdvancedSearchQueryVariables>;
export function useGetCasesAdvancedSearchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCasesAdvancedSearchQuery, GetCasesAdvancedSearchQueryVariables>): Apollo.UseSuspenseQueryResult<GetCasesAdvancedSearchQuery | undefined, GetCasesAdvancedSearchQueryVariables>;
export function useGetCasesAdvancedSearchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCasesAdvancedSearchQuery, GetCasesAdvancedSearchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCasesAdvancedSearchQuery, GetCasesAdvancedSearchQueryVariables>(GetCasesAdvancedSearchDocument, options);
        }
export type GetCasesAdvancedSearchQueryHookResult = ReturnType<typeof useGetCasesAdvancedSearchQuery>;
export type GetCasesAdvancedSearchLazyQueryHookResult = ReturnType<typeof useGetCasesAdvancedSearchLazyQuery>;
export type GetCasesAdvancedSearchSuspenseQueryHookResult = ReturnType<typeof useGetCasesAdvancedSearchSuspenseQuery>;
export type GetCasesAdvancedSearchQueryResult = Apollo.QueryResult<GetCasesAdvancedSearchQuery, GetCasesAdvancedSearchQueryVariables>;
export const GetCaseCommentsDocument = gql`
    query GetCaseComments($caseId: String!, $xDevoDomain: String) @endpoint(name: asoc) {
  getCaseComments(caseId: $caseId, xDevoDomain: $xDevoDomain) {
    data
  }
}
    `;

/**
 * __useGetCaseCommentsQuery__
 *
 * To run a query within a React component, call `useGetCaseCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCaseCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCaseCommentsQuery({
 *   variables: {
 *      caseId: // value for 'caseId'
 *      xDevoDomain: // value for 'xDevoDomain'
 *   },
 * });
 */
export function useGetCaseCommentsQuery(baseOptions: Apollo.QueryHookOptions<GetCaseCommentsQuery, GetCaseCommentsQueryVariables> & ({ variables: GetCaseCommentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCaseCommentsQuery, GetCaseCommentsQueryVariables>(GetCaseCommentsDocument, options);
      }
export function useGetCaseCommentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCaseCommentsQuery, GetCaseCommentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCaseCommentsQuery, GetCaseCommentsQueryVariables>(GetCaseCommentsDocument, options);
        }
// @ts-ignore
export function useGetCaseCommentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCaseCommentsQuery, GetCaseCommentsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCaseCommentsQuery, GetCaseCommentsQueryVariables>;
export function useGetCaseCommentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCaseCommentsQuery, GetCaseCommentsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCaseCommentsQuery | undefined, GetCaseCommentsQueryVariables>;
export function useGetCaseCommentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCaseCommentsQuery, GetCaseCommentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCaseCommentsQuery, GetCaseCommentsQueryVariables>(GetCaseCommentsDocument, options);
        }
export type GetCaseCommentsQueryHookResult = ReturnType<typeof useGetCaseCommentsQuery>;
export type GetCaseCommentsLazyQueryHookResult = ReturnType<typeof useGetCaseCommentsLazyQuery>;
export type GetCaseCommentsSuspenseQueryHookResult = ReturnType<typeof useGetCaseCommentsSuspenseQuery>;
export type GetCaseCommentsQueryResult = Apollo.QueryResult<GetCaseCommentsQuery, GetCaseCommentsQueryVariables>;
export const GetCaseTasksDocument = gql`
    query GetCaseTasks($caseId: String!, $xDevoDomain: String) @endpoint(name: asoc) {
  getCaseTasks(caseId: $caseId, xDevoDomain: $xDevoDomain) {
    data
  }
}
    `;

/**
 * __useGetCaseTasksQuery__
 *
 * To run a query within a React component, call `useGetCaseTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCaseTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCaseTasksQuery({
 *   variables: {
 *      caseId: // value for 'caseId'
 *      xDevoDomain: // value for 'xDevoDomain'
 *   },
 * });
 */
export function useGetCaseTasksQuery(baseOptions: Apollo.QueryHookOptions<GetCaseTasksQuery, GetCaseTasksQueryVariables> & ({ variables: GetCaseTasksQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCaseTasksQuery, GetCaseTasksQueryVariables>(GetCaseTasksDocument, options);
      }
export function useGetCaseTasksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCaseTasksQuery, GetCaseTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCaseTasksQuery, GetCaseTasksQueryVariables>(GetCaseTasksDocument, options);
        }
// @ts-ignore
export function useGetCaseTasksSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCaseTasksQuery, GetCaseTasksQueryVariables>): Apollo.UseSuspenseQueryResult<GetCaseTasksQuery, GetCaseTasksQueryVariables>;
export function useGetCaseTasksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCaseTasksQuery, GetCaseTasksQueryVariables>): Apollo.UseSuspenseQueryResult<GetCaseTasksQuery | undefined, GetCaseTasksQueryVariables>;
export function useGetCaseTasksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCaseTasksQuery, GetCaseTasksQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCaseTasksQuery, GetCaseTasksQueryVariables>(GetCaseTasksDocument, options);
        }
export type GetCaseTasksQueryHookResult = ReturnType<typeof useGetCaseTasksQuery>;
export type GetCaseTasksLazyQueryHookResult = ReturnType<typeof useGetCaseTasksLazyQuery>;
export type GetCaseTasksSuspenseQueryHookResult = ReturnType<typeof useGetCaseTasksSuspenseQuery>;
export type GetCaseTasksQueryResult = Apollo.QueryResult<GetCaseTasksQuery, GetCaseTasksQueryVariables>;
export const GetCaseWorkflowDocument = gql`
    query GetCaseWorkflow($caseId: String!, $xDevoDomain: String) @endpoint(name: asoc) {
  getCaseWorkflow(caseId: $caseId, xDevoDomain: $xDevoDomain) {
    data
  }
}
    `;

/**
 * __useGetCaseWorkflowQuery__
 *
 * To run a query within a React component, call `useGetCaseWorkflowQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCaseWorkflowQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCaseWorkflowQuery({
 *   variables: {
 *      caseId: // value for 'caseId'
 *      xDevoDomain: // value for 'xDevoDomain'
 *   },
 * });
 */
export function useGetCaseWorkflowQuery(baseOptions: Apollo.QueryHookOptions<GetCaseWorkflowQuery, GetCaseWorkflowQueryVariables> & ({ variables: GetCaseWorkflowQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCaseWorkflowQuery, GetCaseWorkflowQueryVariables>(GetCaseWorkflowDocument, options);
      }
export function useGetCaseWorkflowLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCaseWorkflowQuery, GetCaseWorkflowQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCaseWorkflowQuery, GetCaseWorkflowQueryVariables>(GetCaseWorkflowDocument, options);
        }
// @ts-ignore
export function useGetCaseWorkflowSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCaseWorkflowQuery, GetCaseWorkflowQueryVariables>): Apollo.UseSuspenseQueryResult<GetCaseWorkflowQuery, GetCaseWorkflowQueryVariables>;
export function useGetCaseWorkflowSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCaseWorkflowQuery, GetCaseWorkflowQueryVariables>): Apollo.UseSuspenseQueryResult<GetCaseWorkflowQuery | undefined, GetCaseWorkflowQueryVariables>;
export function useGetCaseWorkflowSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCaseWorkflowQuery, GetCaseWorkflowQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCaseWorkflowQuery, GetCaseWorkflowQueryVariables>(GetCaseWorkflowDocument, options);
        }
export type GetCaseWorkflowQueryHookResult = ReturnType<typeof useGetCaseWorkflowQuery>;
export type GetCaseWorkflowLazyQueryHookResult = ReturnType<typeof useGetCaseWorkflowLazyQuery>;
export type GetCaseWorkflowSuspenseQueryHookResult = ReturnType<typeof useGetCaseWorkflowSuspenseQuery>;
export type GetCaseWorkflowQueryResult = Apollo.QueryResult<GetCaseWorkflowQuery, GetCaseWorkflowQueryVariables>;
export const GetCaseAttachmentsDocument = gql`
    query GetCaseAttachments($caseId: String!, $xDevoDomain: String) @endpoint(name: asoc) {
  getCaseAttachments(caseId: $caseId, xDevoDomain: $xDevoDomain) {
    data
  }
}
    `;

/**
 * __useGetCaseAttachmentsQuery__
 *
 * To run a query within a React component, call `useGetCaseAttachmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCaseAttachmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCaseAttachmentsQuery({
 *   variables: {
 *      caseId: // value for 'caseId'
 *      xDevoDomain: // value for 'xDevoDomain'
 *   },
 * });
 */
export function useGetCaseAttachmentsQuery(baseOptions: Apollo.QueryHookOptions<GetCaseAttachmentsQuery, GetCaseAttachmentsQueryVariables> & ({ variables: GetCaseAttachmentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCaseAttachmentsQuery, GetCaseAttachmentsQueryVariables>(GetCaseAttachmentsDocument, options);
      }
export function useGetCaseAttachmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCaseAttachmentsQuery, GetCaseAttachmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCaseAttachmentsQuery, GetCaseAttachmentsQueryVariables>(GetCaseAttachmentsDocument, options);
        }
// @ts-ignore
export function useGetCaseAttachmentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCaseAttachmentsQuery, GetCaseAttachmentsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCaseAttachmentsQuery, GetCaseAttachmentsQueryVariables>;
export function useGetCaseAttachmentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCaseAttachmentsQuery, GetCaseAttachmentsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCaseAttachmentsQuery | undefined, GetCaseAttachmentsQueryVariables>;
export function useGetCaseAttachmentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCaseAttachmentsQuery, GetCaseAttachmentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCaseAttachmentsQuery, GetCaseAttachmentsQueryVariables>(GetCaseAttachmentsDocument, options);
        }
export type GetCaseAttachmentsQueryHookResult = ReturnType<typeof useGetCaseAttachmentsQuery>;
export type GetCaseAttachmentsLazyQueryHookResult = ReturnType<typeof useGetCaseAttachmentsLazyQuery>;
export type GetCaseAttachmentsSuspenseQueryHookResult = ReturnType<typeof useGetCaseAttachmentsSuspenseQuery>;
export type GetCaseAttachmentsQueryResult = Apollo.QueryResult<GetCaseAttachmentsQuery, GetCaseAttachmentsQueryVariables>;
export const GetAlertDetailsDocument = gql`
    query GetAlertDetails($alertId: String!, $timezone: String, $xDevoDomain: String) @endpoint(name: asoc) {
  getDevoAlertDetails(
    alertId: $alertId
    timezone: $timezone
    xDevoDomain: $xDevoDomain
  ) {
    data
  }
}
    `;

/**
 * __useGetAlertDetailsQuery__
 *
 * To run a query within a React component, call `useGetAlertDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAlertDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAlertDetailsQuery({
 *   variables: {
 *      alertId: // value for 'alertId'
 *      timezone: // value for 'timezone'
 *      xDevoDomain: // value for 'xDevoDomain'
 *   },
 * });
 */
export function useGetAlertDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetAlertDetailsQuery, GetAlertDetailsQueryVariables> & ({ variables: GetAlertDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAlertDetailsQuery, GetAlertDetailsQueryVariables>(GetAlertDetailsDocument, options);
      }
export function useGetAlertDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAlertDetailsQuery, GetAlertDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAlertDetailsQuery, GetAlertDetailsQueryVariables>(GetAlertDetailsDocument, options);
        }
// @ts-ignore
export function useGetAlertDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAlertDetailsQuery, GetAlertDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAlertDetailsQuery, GetAlertDetailsQueryVariables>;
export function useGetAlertDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAlertDetailsQuery, GetAlertDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAlertDetailsQuery | undefined, GetAlertDetailsQueryVariables>;
export function useGetAlertDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAlertDetailsQuery, GetAlertDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAlertDetailsQuery, GetAlertDetailsQueryVariables>(GetAlertDetailsDocument, options);
        }
export type GetAlertDetailsQueryHookResult = ReturnType<typeof useGetAlertDetailsQuery>;
export type GetAlertDetailsLazyQueryHookResult = ReturnType<typeof useGetAlertDetailsLazyQuery>;
export type GetAlertDetailsSuspenseQueryHookResult = ReturnType<typeof useGetAlertDetailsSuspenseQuery>;
export type GetAlertDetailsQueryResult = Apollo.QueryResult<GetAlertDetailsQuery, GetAlertDetailsQueryVariables>;
export const GetAlertQueryIntervalDocument = gql`
    query GetAlertQueryInterval($alertId: String!, $xDevoDomain: String) @endpoint(name: asoc) {
  getDevoAlertQueryInterval(alertId: $alertId, xDevoDomain: $xDevoDomain) {
    data
  }
}
    `;

/**
 * __useGetAlertQueryIntervalQuery__
 *
 * To run a query within a React component, call `useGetAlertQueryIntervalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAlertQueryIntervalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAlertQueryIntervalQuery({
 *   variables: {
 *      alertId: // value for 'alertId'
 *      xDevoDomain: // value for 'xDevoDomain'
 *   },
 * });
 */
export function useGetAlertQueryIntervalQuery(baseOptions: Apollo.QueryHookOptions<GetAlertQueryIntervalQuery, GetAlertQueryIntervalQueryVariables> & ({ variables: GetAlertQueryIntervalQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAlertQueryIntervalQuery, GetAlertQueryIntervalQueryVariables>(GetAlertQueryIntervalDocument, options);
      }
export function useGetAlertQueryIntervalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAlertQueryIntervalQuery, GetAlertQueryIntervalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAlertQueryIntervalQuery, GetAlertQueryIntervalQueryVariables>(GetAlertQueryIntervalDocument, options);
        }
// @ts-ignore
export function useGetAlertQueryIntervalSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAlertQueryIntervalQuery, GetAlertQueryIntervalQueryVariables>): Apollo.UseSuspenseQueryResult<GetAlertQueryIntervalQuery, GetAlertQueryIntervalQueryVariables>;
export function useGetAlertQueryIntervalSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAlertQueryIntervalQuery, GetAlertQueryIntervalQueryVariables>): Apollo.UseSuspenseQueryResult<GetAlertQueryIntervalQuery | undefined, GetAlertQueryIntervalQueryVariables>;
export function useGetAlertQueryIntervalSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAlertQueryIntervalQuery, GetAlertQueryIntervalQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAlertQueryIntervalQuery, GetAlertQueryIntervalQueryVariables>(GetAlertQueryIntervalDocument, options);
        }
export type GetAlertQueryIntervalQueryHookResult = ReturnType<typeof useGetAlertQueryIntervalQuery>;
export type GetAlertQueryIntervalLazyQueryHookResult = ReturnType<typeof useGetAlertQueryIntervalLazyQuery>;
export type GetAlertQueryIntervalSuspenseQueryHookResult = ReturnType<typeof useGetAlertQueryIntervalSuspenseQuery>;
export type GetAlertQueryIntervalQueryResult = Apollo.QueryResult<GetAlertQueryIntervalQuery, GetAlertQueryIntervalQueryVariables>;
export const GetSimilarCasesDocument = gql`
    query GetSimilarCases($caseId: String!, $filterFields: [String], $minimumMatches: Int, $offset: Int, $sortFieldName: String, $sortOrder: String, $xDevoDomain: String) @endpoint(name: asoc) {
  getSimilarCases(
    caseId: $caseId
    filterFields: $filterFields
    minimumMatches: $minimumMatches
    offset: $offset
    sortFieldName: $sortFieldName
    sortOrder: $sortOrder
    xDevoDomain: $xDevoDomain
  ) {
    data
  }
}
    `;

/**
 * __useGetSimilarCasesQuery__
 *
 * To run a query within a React component, call `useGetSimilarCasesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSimilarCasesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSimilarCasesQuery({
 *   variables: {
 *      caseId: // value for 'caseId'
 *      filterFields: // value for 'filterFields'
 *      minimumMatches: // value for 'minimumMatches'
 *      offset: // value for 'offset'
 *      sortFieldName: // value for 'sortFieldName'
 *      sortOrder: // value for 'sortOrder'
 *      xDevoDomain: // value for 'xDevoDomain'
 *   },
 * });
 */
export function useGetSimilarCasesQuery(baseOptions: Apollo.QueryHookOptions<GetSimilarCasesQuery, GetSimilarCasesQueryVariables> & ({ variables: GetSimilarCasesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSimilarCasesQuery, GetSimilarCasesQueryVariables>(GetSimilarCasesDocument, options);
      }
export function useGetSimilarCasesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSimilarCasesQuery, GetSimilarCasesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSimilarCasesQuery, GetSimilarCasesQueryVariables>(GetSimilarCasesDocument, options);
        }
// @ts-ignore
export function useGetSimilarCasesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSimilarCasesQuery, GetSimilarCasesQueryVariables>): Apollo.UseSuspenseQueryResult<GetSimilarCasesQuery, GetSimilarCasesQueryVariables>;
export function useGetSimilarCasesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSimilarCasesQuery, GetSimilarCasesQueryVariables>): Apollo.UseSuspenseQueryResult<GetSimilarCasesQuery | undefined, GetSimilarCasesQueryVariables>;
export function useGetSimilarCasesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSimilarCasesQuery, GetSimilarCasesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSimilarCasesQuery, GetSimilarCasesQueryVariables>(GetSimilarCasesDocument, options);
        }
export type GetSimilarCasesQueryHookResult = ReturnType<typeof useGetSimilarCasesQuery>;
export type GetSimilarCasesLazyQueryHookResult = ReturnType<typeof useGetSimilarCasesLazyQuery>;
export type GetSimilarCasesSuspenseQueryHookResult = ReturnType<typeof useGetSimilarCasesSuspenseQuery>;
export type GetSimilarCasesQueryResult = Apollo.QueryResult<GetSimilarCasesQuery, GetSimilarCasesQueryVariables>;
export const GetLinkedCasesDocument = gql`
    query GetLinkedCases($caseId: String!, $xDevoDomain: String) @endpoint(name: asoc) {
  getLinkedCases(caseId: $caseId, xDevoDomain: $xDevoDomain) {
    data
  }
}
    `;

/**
 * __useGetLinkedCasesQuery__
 *
 * To run a query within a React component, call `useGetLinkedCasesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLinkedCasesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLinkedCasesQuery({
 *   variables: {
 *      caseId: // value for 'caseId'
 *      xDevoDomain: // value for 'xDevoDomain'
 *   },
 * });
 */
export function useGetLinkedCasesQuery(baseOptions: Apollo.QueryHookOptions<GetLinkedCasesQuery, GetLinkedCasesQueryVariables> & ({ variables: GetLinkedCasesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLinkedCasesQuery, GetLinkedCasesQueryVariables>(GetLinkedCasesDocument, options);
      }
export function useGetLinkedCasesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLinkedCasesQuery, GetLinkedCasesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLinkedCasesQuery, GetLinkedCasesQueryVariables>(GetLinkedCasesDocument, options);
        }
// @ts-ignore
export function useGetLinkedCasesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetLinkedCasesQuery, GetLinkedCasesQueryVariables>): Apollo.UseSuspenseQueryResult<GetLinkedCasesQuery, GetLinkedCasesQueryVariables>;
export function useGetLinkedCasesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLinkedCasesQuery, GetLinkedCasesQueryVariables>): Apollo.UseSuspenseQueryResult<GetLinkedCasesQuery | undefined, GetLinkedCasesQueryVariables>;
export function useGetLinkedCasesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLinkedCasesQuery, GetLinkedCasesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLinkedCasesQuery, GetLinkedCasesQueryVariables>(GetLinkedCasesDocument, options);
        }
export type GetLinkedCasesQueryHookResult = ReturnType<typeof useGetLinkedCasesQuery>;
export type GetLinkedCasesLazyQueryHookResult = ReturnType<typeof useGetLinkedCasesLazyQuery>;
export type GetLinkedCasesSuspenseQueryHookResult = ReturnType<typeof useGetLinkedCasesSuspenseQuery>;
export type GetLinkedCasesQueryResult = Apollo.QueryResult<GetLinkedCasesQuery, GetLinkedCasesQueryVariables>;
export const ExecuteSearchDocument = gql`
    query ExecuteSearch($query: String!, $from: String!, $to: String!, $limit: Int, $offset: Int) @endpoint(name: asoc) {
  executeSearch(
    query: $query
    from: $from
    to: $to
    limit: $limit
    offset: $offset
  )
}
    `;

/**
 * __useExecuteSearchQuery__
 *
 * To run a query within a React component, call `useExecuteSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useExecuteSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExecuteSearchQuery({
 *   variables: {
 *      query: // value for 'query'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useExecuteSearchQuery(baseOptions: Apollo.QueryHookOptions<ExecuteSearchQuery, ExecuteSearchQueryVariables> & ({ variables: ExecuteSearchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExecuteSearchQuery, ExecuteSearchQueryVariables>(ExecuteSearchDocument, options);
      }
export function useExecuteSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExecuteSearchQuery, ExecuteSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExecuteSearchQuery, ExecuteSearchQueryVariables>(ExecuteSearchDocument, options);
        }
// @ts-ignore
export function useExecuteSearchSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ExecuteSearchQuery, ExecuteSearchQueryVariables>): Apollo.UseSuspenseQueryResult<ExecuteSearchQuery, ExecuteSearchQueryVariables>;
export function useExecuteSearchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExecuteSearchQuery, ExecuteSearchQueryVariables>): Apollo.UseSuspenseQueryResult<ExecuteSearchQuery | undefined, ExecuteSearchQueryVariables>;
export function useExecuteSearchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExecuteSearchQuery, ExecuteSearchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ExecuteSearchQuery, ExecuteSearchQueryVariables>(ExecuteSearchDocument, options);
        }
export type ExecuteSearchQueryHookResult = ReturnType<typeof useExecuteSearchQuery>;
export type ExecuteSearchLazyQueryHookResult = ReturnType<typeof useExecuteSearchLazyQuery>;
export type ExecuteSearchSuspenseQueryHookResult = ReturnType<typeof useExecuteSearchSuspenseQuery>;
export type ExecuteSearchQueryResult = Apollo.QueryResult<ExecuteSearchQuery, ExecuteSearchQueryVariables>;
export const ExecuteHistogramDocument = gql`
    query ExecuteHistogram($query: String!, $from: String!, $to: String!, $timeGap: String) @endpoint(name: asoc) {
  executeHistogram(query: $query, from: $from, to: $to, timeGap: $timeGap)
}
    `;

/**
 * __useExecuteHistogramQuery__
 *
 * To run a query within a React component, call `useExecuteHistogramQuery` and pass it any options that fit your needs.
 * When your component renders, `useExecuteHistogramQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExecuteHistogramQuery({
 *   variables: {
 *      query: // value for 'query'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      timeGap: // value for 'timeGap'
 *   },
 * });
 */
export function useExecuteHistogramQuery(baseOptions: Apollo.QueryHookOptions<ExecuteHistogramQuery, ExecuteHistogramQueryVariables> & ({ variables: ExecuteHistogramQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExecuteHistogramQuery, ExecuteHistogramQueryVariables>(ExecuteHistogramDocument, options);
      }
export function useExecuteHistogramLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExecuteHistogramQuery, ExecuteHistogramQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExecuteHistogramQuery, ExecuteHistogramQueryVariables>(ExecuteHistogramDocument, options);
        }
// @ts-ignore
export function useExecuteHistogramSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ExecuteHistogramQuery, ExecuteHistogramQueryVariables>): Apollo.UseSuspenseQueryResult<ExecuteHistogramQuery, ExecuteHistogramQueryVariables>;
export function useExecuteHistogramSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExecuteHistogramQuery, ExecuteHistogramQueryVariables>): Apollo.UseSuspenseQueryResult<ExecuteHistogramQuery | undefined, ExecuteHistogramQueryVariables>;
export function useExecuteHistogramSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExecuteHistogramQuery, ExecuteHistogramQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ExecuteHistogramQuery, ExecuteHistogramQueryVariables>(ExecuteHistogramDocument, options);
        }
export type ExecuteHistogramQueryHookResult = ReturnType<typeof useExecuteHistogramQuery>;
export type ExecuteHistogramLazyQueryHookResult = ReturnType<typeof useExecuteHistogramLazyQuery>;
export type ExecuteHistogramSuspenseQueryHookResult = ReturnType<typeof useExecuteHistogramSuspenseQuery>;
export type ExecuteHistogramQueryResult = Apollo.QueryResult<ExecuteHistogramQuery, ExecuteHistogramQueryVariables>;
export const TableSignatureDocument = gql`
    query TableSignature($signature: String!) @endpoint(name: asoc) {
  tableSignature(signature: $signature)
}
    `;

/**
 * __useTableSignatureQuery__
 *
 * To run a query within a React component, call `useTableSignatureQuery` and pass it any options that fit your needs.
 * When your component renders, `useTableSignatureQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTableSignatureQuery({
 *   variables: {
 *      signature: // value for 'signature'
 *   },
 * });
 */
export function useTableSignatureQuery(baseOptions: Apollo.QueryHookOptions<TableSignatureQuery, TableSignatureQueryVariables> & ({ variables: TableSignatureQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TableSignatureQuery, TableSignatureQueryVariables>(TableSignatureDocument, options);
      }
export function useTableSignatureLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TableSignatureQuery, TableSignatureQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TableSignatureQuery, TableSignatureQueryVariables>(TableSignatureDocument, options);
        }
// @ts-ignore
export function useTableSignatureSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TableSignatureQuery, TableSignatureQueryVariables>): Apollo.UseSuspenseQueryResult<TableSignatureQuery, TableSignatureQueryVariables>;
export function useTableSignatureSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TableSignatureQuery, TableSignatureQueryVariables>): Apollo.UseSuspenseQueryResult<TableSignatureQuery | undefined, TableSignatureQueryVariables>;
export function useTableSignatureSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TableSignatureQuery, TableSignatureQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TableSignatureQuery, TableSignatureQueryVariables>(TableSignatureDocument, options);
        }
export type TableSignatureQueryHookResult = ReturnType<typeof useTableSignatureQuery>;
export type TableSignatureLazyQueryHookResult = ReturnType<typeof useTableSignatureLazyQuery>;
export type TableSignatureSuspenseQueryHookResult = ReturnType<typeof useTableSignatureSuspenseQuery>;
export type TableSignatureQueryResult = Apollo.QueryResult<TableSignatureQuery, TableSignatureQueryVariables>;
export const PostCommentDocument = gql`
    mutation PostComment($caseId: String!, $input: PostCommentInput!, $xDevoDomain: String) @endpoint(name: asoc) {
  postComment(caseId: $caseId, input: $input, xDevoDomain: $xDevoDomain) {
    data
  }
}
    `;
export type PostCommentMutationFn = Apollo.MutationFunction<PostCommentMutation, PostCommentMutationVariables>;

/**
 * __usePostCommentMutation__
 *
 * To run a mutation, you first call `usePostCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePostCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [postCommentMutation, { data, loading, error }] = usePostCommentMutation({
 *   variables: {
 *      caseId: // value for 'caseId'
 *      input: // value for 'input'
 *      xDevoDomain: // value for 'xDevoDomain'
 *   },
 * });
 */
export function usePostCommentMutation(baseOptions?: Apollo.MutationHookOptions<PostCommentMutation, PostCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PostCommentMutation, PostCommentMutationVariables>(PostCommentDocument, options);
      }
export type PostCommentMutationHookResult = ReturnType<typeof usePostCommentMutation>;
export type PostCommentMutationResult = Apollo.MutationResult<PostCommentMutation>;
export type PostCommentMutationOptions = Apollo.BaseMutationOptions<PostCommentMutation, PostCommentMutationVariables>;
export const DeleteCommentDocument = gql`
    mutation DeleteComment($commentId: String!, $xDevoDomain: String) @endpoint(name: asoc) {
  deleteComment(commentId: $commentId, xDevoDomain: $xDevoDomain) {
    data
  }
}
    `;
export type DeleteCommentMutationFn = Apollo.MutationFunction<DeleteCommentMutation, DeleteCommentMutationVariables>;

/**
 * __useDeleteCommentMutation__
 *
 * To run a mutation, you first call `useDeleteCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCommentMutation, { data, loading, error }] = useDeleteCommentMutation({
 *   variables: {
 *      commentId: // value for 'commentId'
 *      xDevoDomain: // value for 'xDevoDomain'
 *   },
 * });
 */
export function useDeleteCommentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCommentMutation, DeleteCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCommentMutation, DeleteCommentMutationVariables>(DeleteCommentDocument, options);
      }
export type DeleteCommentMutationHookResult = ReturnType<typeof useDeleteCommentMutation>;
export type DeleteCommentMutationResult = Apollo.MutationResult<DeleteCommentMutation>;
export type DeleteCommentMutationOptions = Apollo.BaseMutationOptions<DeleteCommentMutation, DeleteCommentMutationVariables>;
export const UpdateCommentDocument = gql`
    mutation UpdateComment($commentId: String!, $input: UpdateCommentInput!, $xDevoDomain: String) @endpoint(name: asoc) {
  updateComment(commentId: $commentId, input: $input, xDevoDomain: $xDevoDomain) {
    data
  }
}
    `;
export type UpdateCommentMutationFn = Apollo.MutationFunction<UpdateCommentMutation, UpdateCommentMutationVariables>;

/**
 * __useUpdateCommentMutation__
 *
 * To run a mutation, you first call `useUpdateCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCommentMutation, { data, loading, error }] = useUpdateCommentMutation({
 *   variables: {
 *      commentId: // value for 'commentId'
 *      input: // value for 'input'
 *      xDevoDomain: // value for 'xDevoDomain'
 *   },
 * });
 */
export function useUpdateCommentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCommentMutation, UpdateCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCommentMutation, UpdateCommentMutationVariables>(UpdateCommentDocument, options);
      }
export type UpdateCommentMutationHookResult = ReturnType<typeof useUpdateCommentMutation>;
export type UpdateCommentMutationResult = Apollo.MutationResult<UpdateCommentMutation>;
export type UpdateCommentMutationOptions = Apollo.BaseMutationOptions<UpdateCommentMutation, UpdateCommentMutationVariables>;
export const CreateCaseDocument = gql`
    mutation CreateCase($input: CreateCaseInput!, $xDevoDomain: String) @endpoint(name: asoc) {
  createCase(input: $input, xDevoDomain: $xDevoDomain) {
    data
  }
}
    `;
export type CreateCaseMutationFn = Apollo.MutationFunction<CreateCaseMutation, CreateCaseMutationVariables>;

/**
 * __useCreateCaseMutation__
 *
 * To run a mutation, you first call `useCreateCaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCaseMutation, { data, loading, error }] = useCreateCaseMutation({
 *   variables: {
 *      input: // value for 'input'
 *      xDevoDomain: // value for 'xDevoDomain'
 *   },
 * });
 */
export function useCreateCaseMutation(baseOptions?: Apollo.MutationHookOptions<CreateCaseMutation, CreateCaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCaseMutation, CreateCaseMutationVariables>(CreateCaseDocument, options);
      }
export type CreateCaseMutationHookResult = ReturnType<typeof useCreateCaseMutation>;
export type CreateCaseMutationResult = Apollo.MutationResult<CreateCaseMutation>;
export type CreateCaseMutationOptions = Apollo.BaseMutationOptions<CreateCaseMutation, CreateCaseMutationVariables>;
export const CreateCaseDirectDocument = gql`
    mutation CreateCaseDirect($input: CreateCaseDirectInput!, $xDevoDomain: String) @endpoint(name: asoc) {
  createCaseDirect(input: $input, xDevoDomain: $xDevoDomain) {
    data
  }
}
    `;
export type CreateCaseDirectMutationFn = Apollo.MutationFunction<CreateCaseDirectMutation, CreateCaseDirectMutationVariables>;

/**
 * __useCreateCaseDirectMutation__
 *
 * To run a mutation, you first call `useCreateCaseDirectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCaseDirectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCaseDirectMutation, { data, loading, error }] = useCreateCaseDirectMutation({
 *   variables: {
 *      input: // value for 'input'
 *      xDevoDomain: // value for 'xDevoDomain'
 *   },
 * });
 */
export function useCreateCaseDirectMutation(baseOptions?: Apollo.MutationHookOptions<CreateCaseDirectMutation, CreateCaseDirectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCaseDirectMutation, CreateCaseDirectMutationVariables>(CreateCaseDirectDocument, options);
      }
export type CreateCaseDirectMutationHookResult = ReturnType<typeof useCreateCaseDirectMutation>;
export type CreateCaseDirectMutationResult = Apollo.MutationResult<CreateCaseDirectMutation>;
export type CreateCaseDirectMutationOptions = Apollo.BaseMutationOptions<CreateCaseDirectMutation, CreateCaseDirectMutationVariables>;
export const UpdateCaseDocument = gql`
    mutation UpdateCase($id: String!, $input: UpdateCaseInput!, $xDevoDomain: String) @endpoint(name: asoc) {
  updateCase(id: $id, input: $input, xDevoDomain: $xDevoDomain) {
    data
  }
}
    `;
export type UpdateCaseMutationFn = Apollo.MutationFunction<UpdateCaseMutation, UpdateCaseMutationVariables>;

/**
 * __useUpdateCaseMutation__
 *
 * To run a mutation, you first call `useUpdateCaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCaseMutation, { data, loading, error }] = useUpdateCaseMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *      xDevoDomain: // value for 'xDevoDomain'
 *   },
 * });
 */
export function useUpdateCaseMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCaseMutation, UpdateCaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCaseMutation, UpdateCaseMutationVariables>(UpdateCaseDocument, options);
      }
export type UpdateCaseMutationHookResult = ReturnType<typeof useUpdateCaseMutation>;
export type UpdateCaseMutationResult = Apollo.MutationResult<UpdateCaseMutation>;
export type UpdateCaseMutationOptions = Apollo.BaseMutationOptions<UpdateCaseMutation, UpdateCaseMutationVariables>;
export const DeleteCaseDocument = gql`
    mutation DeleteCase($caseId: String!, $xDevoDomain: String) @endpoint(name: asoc) {
  deleteCase(caseId: $caseId, xDevoDomain: $xDevoDomain) {
    data
  }
}
    `;
export type DeleteCaseMutationFn = Apollo.MutationFunction<DeleteCaseMutation, DeleteCaseMutationVariables>;

/**
 * __useDeleteCaseMutation__
 *
 * To run a mutation, you first call `useDeleteCaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCaseMutation, { data, loading, error }] = useDeleteCaseMutation({
 *   variables: {
 *      caseId: // value for 'caseId'
 *      xDevoDomain: // value for 'xDevoDomain'
 *   },
 * });
 */
export function useDeleteCaseMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCaseMutation, DeleteCaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCaseMutation, DeleteCaseMutationVariables>(DeleteCaseDocument, options);
      }
export type DeleteCaseMutationHookResult = ReturnType<typeof useDeleteCaseMutation>;
export type DeleteCaseMutationResult = Apollo.MutationResult<DeleteCaseMutation>;
export type DeleteCaseMutationOptions = Apollo.BaseMutationOptions<DeleteCaseMutation, DeleteCaseMutationVariables>;
export const DeleteCasesDocument = gql`
    mutation DeleteCases($caseIds: [String!]!) @endpoint(name: asoc) {
  deleteCases(caseIds: $caseIds) {
    data
  }
}
    `;
export type DeleteCasesMutationFn = Apollo.MutationFunction<DeleteCasesMutation, DeleteCasesMutationVariables>;

/**
 * __useDeleteCasesMutation__
 *
 * To run a mutation, you first call `useDeleteCasesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCasesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCasesMutation, { data, loading, error }] = useDeleteCasesMutation({
 *   variables: {
 *      caseIds: // value for 'caseIds'
 *   },
 * });
 */
export function useDeleteCasesMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCasesMutation, DeleteCasesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCasesMutation, DeleteCasesMutationVariables>(DeleteCasesDocument, options);
      }
export type DeleteCasesMutationHookResult = ReturnType<typeof useDeleteCasesMutation>;
export type DeleteCasesMutationResult = Apollo.MutationResult<DeleteCasesMutation>;
export type DeleteCasesMutationOptions = Apollo.BaseMutationOptions<DeleteCasesMutation, DeleteCasesMutationVariables>;
export const LinkCasesDocument = gql`
    mutation LinkCases($caseId: String!, $linkCaseIds: [String!]!, $xDevoDomain: String) @endpoint(name: asoc) {
  linkCases(caseId: $caseId, linkCaseIds: $linkCaseIds, xDevoDomain: $xDevoDomain) {
    data
  }
}
    `;
export type LinkCasesMutationFn = Apollo.MutationFunction<LinkCasesMutation, LinkCasesMutationVariables>;

/**
 * __useLinkCasesMutation__
 *
 * To run a mutation, you first call `useLinkCasesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkCasesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkCasesMutation, { data, loading, error }] = useLinkCasesMutation({
 *   variables: {
 *      caseId: // value for 'caseId'
 *      linkCaseIds: // value for 'linkCaseIds'
 *      xDevoDomain: // value for 'xDevoDomain'
 *   },
 * });
 */
export function useLinkCasesMutation(baseOptions?: Apollo.MutationHookOptions<LinkCasesMutation, LinkCasesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LinkCasesMutation, LinkCasesMutationVariables>(LinkCasesDocument, options);
      }
export type LinkCasesMutationHookResult = ReturnType<typeof useLinkCasesMutation>;
export type LinkCasesMutationResult = Apollo.MutationResult<LinkCasesMutation>;
export type LinkCasesMutationOptions = Apollo.BaseMutationOptions<LinkCasesMutation, LinkCasesMutationVariables>;
export const UnlinkCasesDocument = gql`
    mutation UnlinkCases($caseId: String!, $unlinkCaseIds: [String!]!, $xDevoDomain: String) @endpoint(name: asoc) {
  unlinkCases(
    caseId: $caseId
    unlinkCaseIds: $unlinkCaseIds
    xDevoDomain: $xDevoDomain
  ) {
    data
  }
}
    `;
export type UnlinkCasesMutationFn = Apollo.MutationFunction<UnlinkCasesMutation, UnlinkCasesMutationVariables>;

/**
 * __useUnlinkCasesMutation__
 *
 * To run a mutation, you first call `useUnlinkCasesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlinkCasesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlinkCasesMutation, { data, loading, error }] = useUnlinkCasesMutation({
 *   variables: {
 *      caseId: // value for 'caseId'
 *      unlinkCaseIds: // value for 'unlinkCaseIds'
 *      xDevoDomain: // value for 'xDevoDomain'
 *   },
 * });
 */
export function useUnlinkCasesMutation(baseOptions?: Apollo.MutationHookOptions<UnlinkCasesMutation, UnlinkCasesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnlinkCasesMutation, UnlinkCasesMutationVariables>(UnlinkCasesDocument, options);
      }
export type UnlinkCasesMutationHookResult = ReturnType<typeof useUnlinkCasesMutation>;
export type UnlinkCasesMutationResult = Apollo.MutationResult<UnlinkCasesMutation>;
export type UnlinkCasesMutationOptions = Apollo.BaseMutationOptions<UnlinkCasesMutation, UnlinkCasesMutationVariables>;
export const UpdateTaskDocument = gql`
    mutation UpdateTask($id: String!, $input: UpdateTaskInput!, $xDevoDomain: String) @endpoint(name: asoc) {
  updateTask(id: $id, input: $input, xDevoDomain: $xDevoDomain) {
    data
  }
}
    `;
export type UpdateTaskMutationFn = Apollo.MutationFunction<UpdateTaskMutation, UpdateTaskMutationVariables>;

/**
 * __useUpdateTaskMutation__
 *
 * To run a mutation, you first call `useUpdateTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTaskMutation, { data, loading, error }] = useUpdateTaskMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *      xDevoDomain: // value for 'xDevoDomain'
 *   },
 * });
 */
export function useUpdateTaskMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTaskMutation, UpdateTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTaskMutation, UpdateTaskMutationVariables>(UpdateTaskDocument, options);
      }
export type UpdateTaskMutationHookResult = ReturnType<typeof useUpdateTaskMutation>;
export type UpdateTaskMutationResult = Apollo.MutationResult<UpdateTaskMutation>;
export type UpdateTaskMutationOptions = Apollo.BaseMutationOptions<UpdateTaskMutation, UpdateTaskMutationVariables>;
export const UploadAttachmentDocument = gql`
    mutation UploadAttachment($input: UploadAttachmentInput!, $xDevoDomain: String) @endpoint(name: asoc) {
  uploadAttachment(input: $input, xDevoDomain: $xDevoDomain) {
    data
  }
}
    `;
export type UploadAttachmentMutationFn = Apollo.MutationFunction<UploadAttachmentMutation, UploadAttachmentMutationVariables>;

/**
 * __useUploadAttachmentMutation__
 *
 * To run a mutation, you first call `useUploadAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadAttachmentMutation, { data, loading, error }] = useUploadAttachmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *      xDevoDomain: // value for 'xDevoDomain'
 *   },
 * });
 */
export function useUploadAttachmentMutation(baseOptions?: Apollo.MutationHookOptions<UploadAttachmentMutation, UploadAttachmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadAttachmentMutation, UploadAttachmentMutationVariables>(UploadAttachmentDocument, options);
      }
export type UploadAttachmentMutationHookResult = ReturnType<typeof useUploadAttachmentMutation>;
export type UploadAttachmentMutationResult = Apollo.MutationResult<UploadAttachmentMutation>;
export type UploadAttachmentMutationOptions = Apollo.BaseMutationOptions<UploadAttachmentMutation, UploadAttachmentMutationVariables>;
export const DeleteAttachmentDocument = gql`
    mutation DeleteAttachment($attachmentId: String!, $xDevoDomain: String) @endpoint(name: asoc) {
  deleteAttachment(attachmentId: $attachmentId, xDevoDomain: $xDevoDomain) {
    data
  }
}
    `;
export type DeleteAttachmentMutationFn = Apollo.MutationFunction<DeleteAttachmentMutation, DeleteAttachmentMutationVariables>;

/**
 * __useDeleteAttachmentMutation__
 *
 * To run a mutation, you first call `useDeleteAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAttachmentMutation, { data, loading, error }] = useDeleteAttachmentMutation({
 *   variables: {
 *      attachmentId: // value for 'attachmentId'
 *      xDevoDomain: // value for 'xDevoDomain'
 *   },
 * });
 */
export function useDeleteAttachmentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAttachmentMutation, DeleteAttachmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAttachmentMutation, DeleteAttachmentMutationVariables>(DeleteAttachmentDocument, options);
      }
export type DeleteAttachmentMutationHookResult = ReturnType<typeof useDeleteAttachmentMutation>;
export type DeleteAttachmentMutationResult = Apollo.MutationResult<DeleteAttachmentMutation>;
export type DeleteAttachmentMutationOptions = Apollo.BaseMutationOptions<DeleteAttachmentMutation, DeleteAttachmentMutationVariables>;
export const UnlinkAlertsFromCaseDocument = gql`
    mutation UnlinkAlertsFromCase($caseId: String!, $alertIds: [String!]!, $xDevoDomain: String) @endpoint(name: asoc) {
  unlinkDevoAlertsFromCase(
    caseId: $caseId
    alertIds: $alertIds
    xDevoDomain: $xDevoDomain
  ) {
    data
  }
}
    `;
export type UnlinkAlertsFromCaseMutationFn = Apollo.MutationFunction<UnlinkAlertsFromCaseMutation, UnlinkAlertsFromCaseMutationVariables>;

/**
 * __useUnlinkAlertsFromCaseMutation__
 *
 * To run a mutation, you first call `useUnlinkAlertsFromCaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlinkAlertsFromCaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlinkAlertsFromCaseMutation, { data, loading, error }] = useUnlinkAlertsFromCaseMutation({
 *   variables: {
 *      caseId: // value for 'caseId'
 *      alertIds: // value for 'alertIds'
 *      xDevoDomain: // value for 'xDevoDomain'
 *   },
 * });
 */
export function useUnlinkAlertsFromCaseMutation(baseOptions?: Apollo.MutationHookOptions<UnlinkAlertsFromCaseMutation, UnlinkAlertsFromCaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnlinkAlertsFromCaseMutation, UnlinkAlertsFromCaseMutationVariables>(UnlinkAlertsFromCaseDocument, options);
      }
export type UnlinkAlertsFromCaseMutationHookResult = ReturnType<typeof useUnlinkAlertsFromCaseMutation>;
export type UnlinkAlertsFromCaseMutationResult = Apollo.MutationResult<UnlinkAlertsFromCaseMutation>;
export type UnlinkAlertsFromCaseMutationOptions = Apollo.BaseMutationOptions<UnlinkAlertsFromCaseMutation, UnlinkAlertsFromCaseMutationVariables>;
export const CreateSavedSearchDocument = gql`
    mutation CreateSavedSearch($input: CreateSavedSearchInput!) @endpoint(name: asoc) {
  createSavedSearch(input: $input) {
    data
  }
}
    `;
export type CreateSavedSearchMutationFn = Apollo.MutationFunction<CreateSavedSearchMutation, CreateSavedSearchMutationVariables>;

/**
 * __useCreateSavedSearchMutation__
 *
 * To run a mutation, you first call `useCreateSavedSearchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSavedSearchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSavedSearchMutation, { data, loading, error }] = useCreateSavedSearchMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSavedSearchMutation(baseOptions?: Apollo.MutationHookOptions<CreateSavedSearchMutation, CreateSavedSearchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSavedSearchMutation, CreateSavedSearchMutationVariables>(CreateSavedSearchDocument, options);
      }
export type CreateSavedSearchMutationHookResult = ReturnType<typeof useCreateSavedSearchMutation>;
export type CreateSavedSearchMutationResult = Apollo.MutationResult<CreateSavedSearchMutation>;
export type CreateSavedSearchMutationOptions = Apollo.BaseMutationOptions<CreateSavedSearchMutation, CreateSavedSearchMutationVariables>;
export const DeleteSavedSearchDocument = gql`
    mutation DeleteSavedSearch($searchId: String!) @endpoint(name: asoc) {
  deleteSavedSearch(searchId: $searchId) {
    data
  }
}
    `;
export type DeleteSavedSearchMutationFn = Apollo.MutationFunction<DeleteSavedSearchMutation, DeleteSavedSearchMutationVariables>;

/**
 * __useDeleteSavedSearchMutation__
 *
 * To run a mutation, you first call `useDeleteSavedSearchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSavedSearchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSavedSearchMutation, { data, loading, error }] = useDeleteSavedSearchMutation({
 *   variables: {
 *      searchId: // value for 'searchId'
 *   },
 * });
 */
export function useDeleteSavedSearchMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSavedSearchMutation, DeleteSavedSearchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSavedSearchMutation, DeleteSavedSearchMutationVariables>(DeleteSavedSearchDocument, options);
      }
export type DeleteSavedSearchMutationHookResult = ReturnType<typeof useDeleteSavedSearchMutation>;
export type DeleteSavedSearchMutationResult = Apollo.MutationResult<DeleteSavedSearchMutation>;
export type DeleteSavedSearchMutationOptions = Apollo.BaseMutationOptions<DeleteSavedSearchMutation, DeleteSavedSearchMutationVariables>;
export const UpdateSavedSearchDocument = gql`
    mutation UpdateSavedSearch($searchId: String!, $input: UpdateSavedSearchInput!) @endpoint(name: asoc) {
  updateSavedSearch(searchId: $searchId, input: $input) {
    data
  }
}
    `;
export type UpdateSavedSearchMutationFn = Apollo.MutationFunction<UpdateSavedSearchMutation, UpdateSavedSearchMutationVariables>;

/**
 * __useUpdateSavedSearchMutation__
 *
 * To run a mutation, you first call `useUpdateSavedSearchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSavedSearchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSavedSearchMutation, { data, loading, error }] = useUpdateSavedSearchMutation({
 *   variables: {
 *      searchId: // value for 'searchId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSavedSearchMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSavedSearchMutation, UpdateSavedSearchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSavedSearchMutation, UpdateSavedSearchMutationVariables>(UpdateSavedSearchDocument, options);
      }
export type UpdateSavedSearchMutationHookResult = ReturnType<typeof useUpdateSavedSearchMutation>;
export type UpdateSavedSearchMutationResult = Apollo.MutationResult<UpdateSavedSearchMutation>;
export type UpdateSavedSearchMutationOptions = Apollo.BaseMutationOptions<UpdateSavedSearchMutation, UpdateSavedSearchMutationVariables>;
export const GetCaseAlertsDocument = gql`
    query GetCaseAlerts($caseId: String!, $pageNumber: Int, $pageSize: Int, $groupName: String, $xDevoDomain: String) @endpoint(name: asoc) {
  getDevoCaseAlerts(
    caseId: $caseId
    pageNumber: $pageNumber
    pageSize: $pageSize
    groupName: $groupName
    xDevoDomain: $xDevoDomain
  ) {
    data
  }
}
    `;

/**
 * __useGetCaseAlertsQuery__
 *
 * To run a query within a React component, call `useGetCaseAlertsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCaseAlertsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCaseAlertsQuery({
 *   variables: {
 *      caseId: // value for 'caseId'
 *      pageNumber: // value for 'pageNumber'
 *      pageSize: // value for 'pageSize'
 *      groupName: // value for 'groupName'
 *      xDevoDomain: // value for 'xDevoDomain'
 *   },
 * });
 */
export function useGetCaseAlertsQuery(baseOptions: Apollo.QueryHookOptions<GetCaseAlertsQuery, GetCaseAlertsQueryVariables> & ({ variables: GetCaseAlertsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCaseAlertsQuery, GetCaseAlertsQueryVariables>(GetCaseAlertsDocument, options);
      }
export function useGetCaseAlertsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCaseAlertsQuery, GetCaseAlertsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCaseAlertsQuery, GetCaseAlertsQueryVariables>(GetCaseAlertsDocument, options);
        }
// @ts-ignore
export function useGetCaseAlertsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCaseAlertsQuery, GetCaseAlertsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCaseAlertsQuery, GetCaseAlertsQueryVariables>;
export function useGetCaseAlertsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCaseAlertsQuery, GetCaseAlertsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCaseAlertsQuery | undefined, GetCaseAlertsQueryVariables>;
export function useGetCaseAlertsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCaseAlertsQuery, GetCaseAlertsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCaseAlertsQuery, GetCaseAlertsQueryVariables>(GetCaseAlertsDocument, options);
        }
export type GetCaseAlertsQueryHookResult = ReturnType<typeof useGetCaseAlertsQuery>;
export type GetCaseAlertsLazyQueryHookResult = ReturnType<typeof useGetCaseAlertsLazyQuery>;
export type GetCaseAlertsSuspenseQueryHookResult = ReturnType<typeof useGetCaseAlertsSuspenseQuery>;
export type GetCaseAlertsQueryResult = Apollo.QueryResult<GetCaseAlertsQuery, GetCaseAlertsQueryVariables>;
export const GetCaseAlertsGroupedDocument = gql`
    query GetCaseAlertsGrouped($caseId: String!, $pageNumber: Int, $pageSize: Int, $xDevoDomain: String) @endpoint(name: asoc) {
  getDevoCaseAlertsGrouped(
    caseId: $caseId
    pageNumber: $pageNumber
    pageSize: $pageSize
    xDevoDomain: $xDevoDomain
  ) {
    data
  }
}
    `;

/**
 * __useGetCaseAlertsGroupedQuery__
 *
 * To run a query within a React component, call `useGetCaseAlertsGroupedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCaseAlertsGroupedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCaseAlertsGroupedQuery({
 *   variables: {
 *      caseId: // value for 'caseId'
 *      pageNumber: // value for 'pageNumber'
 *      pageSize: // value for 'pageSize'
 *      xDevoDomain: // value for 'xDevoDomain'
 *   },
 * });
 */
export function useGetCaseAlertsGroupedQuery(baseOptions: Apollo.QueryHookOptions<GetCaseAlertsGroupedQuery, GetCaseAlertsGroupedQueryVariables> & ({ variables: GetCaseAlertsGroupedQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCaseAlertsGroupedQuery, GetCaseAlertsGroupedQueryVariables>(GetCaseAlertsGroupedDocument, options);
      }
export function useGetCaseAlertsGroupedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCaseAlertsGroupedQuery, GetCaseAlertsGroupedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCaseAlertsGroupedQuery, GetCaseAlertsGroupedQueryVariables>(GetCaseAlertsGroupedDocument, options);
        }
// @ts-ignore
export function useGetCaseAlertsGroupedSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCaseAlertsGroupedQuery, GetCaseAlertsGroupedQueryVariables>): Apollo.UseSuspenseQueryResult<GetCaseAlertsGroupedQuery, GetCaseAlertsGroupedQueryVariables>;
export function useGetCaseAlertsGroupedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCaseAlertsGroupedQuery, GetCaseAlertsGroupedQueryVariables>): Apollo.UseSuspenseQueryResult<GetCaseAlertsGroupedQuery | undefined, GetCaseAlertsGroupedQueryVariables>;
export function useGetCaseAlertsGroupedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCaseAlertsGroupedQuery, GetCaseAlertsGroupedQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCaseAlertsGroupedQuery, GetCaseAlertsGroupedQueryVariables>(GetCaseAlertsGroupedDocument, options);
        }
export type GetCaseAlertsGroupedQueryHookResult = ReturnType<typeof useGetCaseAlertsGroupedQuery>;
export type GetCaseAlertsGroupedLazyQueryHookResult = ReturnType<typeof useGetCaseAlertsGroupedLazyQuery>;
export type GetCaseAlertsGroupedSuspenseQueryHookResult = ReturnType<typeof useGetCaseAlertsGroupedSuspenseQuery>;
export type GetCaseAlertsGroupedQueryResult = Apollo.QueryResult<GetCaseAlertsGroupedQuery, GetCaseAlertsGroupedQueryVariables>;
export const GetVectorSourcesDocument = gql`
    query GetVectorSources @endpoint(name: asoc) {
  getVectorSources {
    data
  }
}
    `;

/**
 * __useGetVectorSourcesQuery__
 *
 * To run a query within a React component, call `useGetVectorSourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVectorSourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVectorSourcesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetVectorSourcesQuery(baseOptions?: Apollo.QueryHookOptions<GetVectorSourcesQuery, GetVectorSourcesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVectorSourcesQuery, GetVectorSourcesQueryVariables>(GetVectorSourcesDocument, options);
      }
export function useGetVectorSourcesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVectorSourcesQuery, GetVectorSourcesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVectorSourcesQuery, GetVectorSourcesQueryVariables>(GetVectorSourcesDocument, options);
        }
// @ts-ignore
export function useGetVectorSourcesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetVectorSourcesQuery, GetVectorSourcesQueryVariables>): Apollo.UseSuspenseQueryResult<GetVectorSourcesQuery, GetVectorSourcesQueryVariables>;
export function useGetVectorSourcesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetVectorSourcesQuery, GetVectorSourcesQueryVariables>): Apollo.UseSuspenseQueryResult<GetVectorSourcesQuery | undefined, GetVectorSourcesQueryVariables>;
export function useGetVectorSourcesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetVectorSourcesQuery, GetVectorSourcesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetVectorSourcesQuery, GetVectorSourcesQueryVariables>(GetVectorSourcesDocument, options);
        }
export type GetVectorSourcesQueryHookResult = ReturnType<typeof useGetVectorSourcesQuery>;
export type GetVectorSourcesLazyQueryHookResult = ReturnType<typeof useGetVectorSourcesLazyQuery>;
export type GetVectorSourcesSuspenseQueryHookResult = ReturnType<typeof useGetVectorSourcesSuspenseQuery>;
export type GetVectorSourcesQueryResult = Apollo.QueryResult<GetVectorSourcesQuery, GetVectorSourcesQueryVariables>;
export const GetVectorDestinationsDocument = gql`
    query GetVectorDestinations @endpoint(name: asoc) {
  getVectorDestinations {
    data
  }
}
    `;

/**
 * __useGetVectorDestinationsQuery__
 *
 * To run a query within a React component, call `useGetVectorDestinationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVectorDestinationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVectorDestinationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetVectorDestinationsQuery(baseOptions?: Apollo.QueryHookOptions<GetVectorDestinationsQuery, GetVectorDestinationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVectorDestinationsQuery, GetVectorDestinationsQueryVariables>(GetVectorDestinationsDocument, options);
      }
export function useGetVectorDestinationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVectorDestinationsQuery, GetVectorDestinationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVectorDestinationsQuery, GetVectorDestinationsQueryVariables>(GetVectorDestinationsDocument, options);
        }
// @ts-ignore
export function useGetVectorDestinationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetVectorDestinationsQuery, GetVectorDestinationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetVectorDestinationsQuery, GetVectorDestinationsQueryVariables>;
export function useGetVectorDestinationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetVectorDestinationsQuery, GetVectorDestinationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetVectorDestinationsQuery | undefined, GetVectorDestinationsQueryVariables>;
export function useGetVectorDestinationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetVectorDestinationsQuery, GetVectorDestinationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetVectorDestinationsQuery, GetVectorDestinationsQueryVariables>(GetVectorDestinationsDocument, options);
        }
export type GetVectorDestinationsQueryHookResult = ReturnType<typeof useGetVectorDestinationsQuery>;
export type GetVectorDestinationsLazyQueryHookResult = ReturnType<typeof useGetVectorDestinationsLazyQuery>;
export type GetVectorDestinationsSuspenseQueryHookResult = ReturnType<typeof useGetVectorDestinationsSuspenseQuery>;
export type GetVectorDestinationsQueryResult = Apollo.QueryResult<GetVectorDestinationsQuery, GetVectorDestinationsQueryVariables>;
export const GetVectorRulesDocument = gql`
    query GetVectorRules @endpoint(name: asoc) {
  getVectorRules {
    data
  }
}
    `;

/**
 * __useGetVectorRulesQuery__
 *
 * To run a query within a React component, call `useGetVectorRulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVectorRulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVectorRulesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetVectorRulesQuery(baseOptions?: Apollo.QueryHookOptions<GetVectorRulesQuery, GetVectorRulesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVectorRulesQuery, GetVectorRulesQueryVariables>(GetVectorRulesDocument, options);
      }
export function useGetVectorRulesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVectorRulesQuery, GetVectorRulesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVectorRulesQuery, GetVectorRulesQueryVariables>(GetVectorRulesDocument, options);
        }
// @ts-ignore
export function useGetVectorRulesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetVectorRulesQuery, GetVectorRulesQueryVariables>): Apollo.UseSuspenseQueryResult<GetVectorRulesQuery, GetVectorRulesQueryVariables>;
export function useGetVectorRulesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetVectorRulesQuery, GetVectorRulesQueryVariables>): Apollo.UseSuspenseQueryResult<GetVectorRulesQuery | undefined, GetVectorRulesQueryVariables>;
export function useGetVectorRulesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetVectorRulesQuery, GetVectorRulesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetVectorRulesQuery, GetVectorRulesQueryVariables>(GetVectorRulesDocument, options);
        }
export type GetVectorRulesQueryHookResult = ReturnType<typeof useGetVectorRulesQuery>;
export type GetVectorRulesLazyQueryHookResult = ReturnType<typeof useGetVectorRulesLazyQuery>;
export type GetVectorRulesSuspenseQueryHookResult = ReturnType<typeof useGetVectorRulesSuspenseQuery>;
export type GetVectorRulesQueryResult = Apollo.QueryResult<GetVectorRulesQuery, GetVectorRulesQueryVariables>;
export const GetVectorConfigDocument = gql`
    query GetVectorConfig @endpoint(name: asoc) {
  getVectorConfig {
    data
  }
}
    `;

/**
 * __useGetVectorConfigQuery__
 *
 * To run a query within a React component, call `useGetVectorConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVectorConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVectorConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetVectorConfigQuery(baseOptions?: Apollo.QueryHookOptions<GetVectorConfigQuery, GetVectorConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVectorConfigQuery, GetVectorConfigQueryVariables>(GetVectorConfigDocument, options);
      }
export function useGetVectorConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVectorConfigQuery, GetVectorConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVectorConfigQuery, GetVectorConfigQueryVariables>(GetVectorConfigDocument, options);
        }
// @ts-ignore
export function useGetVectorConfigSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetVectorConfigQuery, GetVectorConfigQueryVariables>): Apollo.UseSuspenseQueryResult<GetVectorConfigQuery, GetVectorConfigQueryVariables>;
export function useGetVectorConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetVectorConfigQuery, GetVectorConfigQueryVariables>): Apollo.UseSuspenseQueryResult<GetVectorConfigQuery | undefined, GetVectorConfigQueryVariables>;
export function useGetVectorConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetVectorConfigQuery, GetVectorConfigQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetVectorConfigQuery, GetVectorConfigQueryVariables>(GetVectorConfigDocument, options);
        }
export type GetVectorConfigQueryHookResult = ReturnType<typeof useGetVectorConfigQuery>;
export type GetVectorConfigLazyQueryHookResult = ReturnType<typeof useGetVectorConfigLazyQuery>;
export type GetVectorConfigSuspenseQueryHookResult = ReturnType<typeof useGetVectorConfigSuspenseQuery>;
export type GetVectorConfigQueryResult = Apollo.QueryResult<GetVectorConfigQuery, GetVectorConfigQueryVariables>;
export const CreateVectorSourceDocument = gql`
    mutation CreateVectorSource($input: CreateVectorSourceInput!) @endpoint(name: asoc) {
  createVectorSource(input: $input) {
    data
  }
}
    `;
export type CreateVectorSourceMutationFn = Apollo.MutationFunction<CreateVectorSourceMutation, CreateVectorSourceMutationVariables>;

/**
 * __useCreateVectorSourceMutation__
 *
 * To run a mutation, you first call `useCreateVectorSourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVectorSourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVectorSourceMutation, { data, loading, error }] = useCreateVectorSourceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateVectorSourceMutation(baseOptions?: Apollo.MutationHookOptions<CreateVectorSourceMutation, CreateVectorSourceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateVectorSourceMutation, CreateVectorSourceMutationVariables>(CreateVectorSourceDocument, options);
      }
export type CreateVectorSourceMutationHookResult = ReturnType<typeof useCreateVectorSourceMutation>;
export type CreateVectorSourceMutationResult = Apollo.MutationResult<CreateVectorSourceMutation>;
export type CreateVectorSourceMutationOptions = Apollo.BaseMutationOptions<CreateVectorSourceMutation, CreateVectorSourceMutationVariables>;
export const DeleteVectorSourceDocument = gql`
    mutation DeleteVectorSource($name: String!) @endpoint(name: asoc) {
  deleteVectorSource(name: $name) {
    data
  }
}
    `;
export type DeleteVectorSourceMutationFn = Apollo.MutationFunction<DeleteVectorSourceMutation, DeleteVectorSourceMutationVariables>;

/**
 * __useDeleteVectorSourceMutation__
 *
 * To run a mutation, you first call `useDeleteVectorSourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteVectorSourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteVectorSourceMutation, { data, loading, error }] = useDeleteVectorSourceMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useDeleteVectorSourceMutation(baseOptions?: Apollo.MutationHookOptions<DeleteVectorSourceMutation, DeleteVectorSourceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteVectorSourceMutation, DeleteVectorSourceMutationVariables>(DeleteVectorSourceDocument, options);
      }
export type DeleteVectorSourceMutationHookResult = ReturnType<typeof useDeleteVectorSourceMutation>;
export type DeleteVectorSourceMutationResult = Apollo.MutationResult<DeleteVectorSourceMutation>;
export type DeleteVectorSourceMutationOptions = Apollo.BaseMutationOptions<DeleteVectorSourceMutation, DeleteVectorSourceMutationVariables>;
export const CreateVectorDestinationDocument = gql`
    mutation CreateVectorDestination($input: CreateVectorDestinationInput!) @endpoint(name: asoc) {
  createVectorDestination(input: $input) {
    data
  }
}
    `;
export type CreateVectorDestinationMutationFn = Apollo.MutationFunction<CreateVectorDestinationMutation, CreateVectorDestinationMutationVariables>;

/**
 * __useCreateVectorDestinationMutation__
 *
 * To run a mutation, you first call `useCreateVectorDestinationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVectorDestinationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVectorDestinationMutation, { data, loading, error }] = useCreateVectorDestinationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateVectorDestinationMutation(baseOptions?: Apollo.MutationHookOptions<CreateVectorDestinationMutation, CreateVectorDestinationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateVectorDestinationMutation, CreateVectorDestinationMutationVariables>(CreateVectorDestinationDocument, options);
      }
export type CreateVectorDestinationMutationHookResult = ReturnType<typeof useCreateVectorDestinationMutation>;
export type CreateVectorDestinationMutationResult = Apollo.MutationResult<CreateVectorDestinationMutation>;
export type CreateVectorDestinationMutationOptions = Apollo.BaseMutationOptions<CreateVectorDestinationMutation, CreateVectorDestinationMutationVariables>;
export const DeleteVectorDestinationDocument = gql`
    mutation DeleteVectorDestination($name: String!) @endpoint(name: asoc) {
  deleteVectorDestination(name: $name) {
    data
  }
}
    `;
export type DeleteVectorDestinationMutationFn = Apollo.MutationFunction<DeleteVectorDestinationMutation, DeleteVectorDestinationMutationVariables>;

/**
 * __useDeleteVectorDestinationMutation__
 *
 * To run a mutation, you first call `useDeleteVectorDestinationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteVectorDestinationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteVectorDestinationMutation, { data, loading, error }] = useDeleteVectorDestinationMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useDeleteVectorDestinationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteVectorDestinationMutation, DeleteVectorDestinationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteVectorDestinationMutation, DeleteVectorDestinationMutationVariables>(DeleteVectorDestinationDocument, options);
      }
export type DeleteVectorDestinationMutationHookResult = ReturnType<typeof useDeleteVectorDestinationMutation>;
export type DeleteVectorDestinationMutationResult = Apollo.MutationResult<DeleteVectorDestinationMutation>;
export type DeleteVectorDestinationMutationOptions = Apollo.BaseMutationOptions<DeleteVectorDestinationMutation, DeleteVectorDestinationMutationVariables>;
export const CreateVectorRuleDocument = gql`
    mutation CreateVectorRule($input: CreateVectorRuleInput!) @endpoint(name: asoc) {
  createVectorRule(input: $input) {
    data
  }
}
    `;
export type CreateVectorRuleMutationFn = Apollo.MutationFunction<CreateVectorRuleMutation, CreateVectorRuleMutationVariables>;

/**
 * __useCreateVectorRuleMutation__
 *
 * To run a mutation, you first call `useCreateVectorRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVectorRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVectorRuleMutation, { data, loading, error }] = useCreateVectorRuleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateVectorRuleMutation(baseOptions?: Apollo.MutationHookOptions<CreateVectorRuleMutation, CreateVectorRuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateVectorRuleMutation, CreateVectorRuleMutationVariables>(CreateVectorRuleDocument, options);
      }
export type CreateVectorRuleMutationHookResult = ReturnType<typeof useCreateVectorRuleMutation>;
export type CreateVectorRuleMutationResult = Apollo.MutationResult<CreateVectorRuleMutation>;
export type CreateVectorRuleMutationOptions = Apollo.BaseMutationOptions<CreateVectorRuleMutation, CreateVectorRuleMutationVariables>;
export const UpdateVectorRuleDocument = gql`
    mutation UpdateVectorRule($name: String!, $input: UpdateVectorRuleInput!) @endpoint(name: asoc) {
  updateVectorRule(name: $name, input: $input) {
    data
  }
}
    `;
export type UpdateVectorRuleMutationFn = Apollo.MutationFunction<UpdateVectorRuleMutation, UpdateVectorRuleMutationVariables>;

/**
 * __useUpdateVectorRuleMutation__
 *
 * To run a mutation, you first call `useUpdateVectorRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVectorRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVectorRuleMutation, { data, loading, error }] = useUpdateVectorRuleMutation({
 *   variables: {
 *      name: // value for 'name'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateVectorRuleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateVectorRuleMutation, UpdateVectorRuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateVectorRuleMutation, UpdateVectorRuleMutationVariables>(UpdateVectorRuleDocument, options);
      }
export type UpdateVectorRuleMutationHookResult = ReturnType<typeof useUpdateVectorRuleMutation>;
export type UpdateVectorRuleMutationResult = Apollo.MutationResult<UpdateVectorRuleMutation>;
export type UpdateVectorRuleMutationOptions = Apollo.BaseMutationOptions<UpdateVectorRuleMutation, UpdateVectorRuleMutationVariables>;
export const DeleteVectorRuleDocument = gql`
    mutation DeleteVectorRule($name: String!) @endpoint(name: asoc) {
  deleteVectorRule(name: $name) {
    data
  }
}
    `;
export type DeleteVectorRuleMutationFn = Apollo.MutationFunction<DeleteVectorRuleMutation, DeleteVectorRuleMutationVariables>;

/**
 * __useDeleteVectorRuleMutation__
 *
 * To run a mutation, you first call `useDeleteVectorRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteVectorRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteVectorRuleMutation, { data, loading, error }] = useDeleteVectorRuleMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useDeleteVectorRuleMutation(baseOptions?: Apollo.MutationHookOptions<DeleteVectorRuleMutation, DeleteVectorRuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteVectorRuleMutation, DeleteVectorRuleMutationVariables>(DeleteVectorRuleDocument, options);
      }
export type DeleteVectorRuleMutationHookResult = ReturnType<typeof useDeleteVectorRuleMutation>;
export type DeleteVectorRuleMutationResult = Apollo.MutationResult<DeleteVectorRuleMutation>;
export type DeleteVectorRuleMutationOptions = Apollo.BaseMutationOptions<DeleteVectorRuleMutation, DeleteVectorRuleMutationVariables>;